(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["dasa-icons"] = {}, global.React));
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function SvgAgreement$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21.362 7.228h-1.755a1.77 1.77 0 00-.766.18.213.213 0 01-.17.006l-3.66-1.4a2.83 2.83 0 00-2.19.122l-1.807.876a.214.214 0 01-.205-.007 2.534 2.534 0 00-2.248-.17L6.014 7.92a.212.212 0 01-.245-.057 1.807 1.807 0 00-1.376-.635H2.638A.638.638 0 002 7.867v8.085a.638.638 0 00.638.638h1.755a1.807 1.807 0 001.473-.762.215.215 0 01.17-.089h.792c.048 0 .094.016.132.045l2.378 1.872.019.017a1.648 1.648 0 002.212.104l2.602-2.134a.216.216 0 01.094-.044l3.315-.663a.213.213 0 01.25.171 1.8 1.8 0 001.775 1.484h1.757a.638.638 0 00.638-.638V7.868a.639.639 0 00-.638-.64zm-6.993 6.054l-.964.806-.02.014a.798.798 0 00-.104.085l-.008.007-2.585 2.163a.187.187 0 01-.235 0L7.729 14.21a.851.851 0 00-.526-.18h-.788a.213.213 0 01-.212-.214V9.83a.211.211 0 01.129-.195L9.207 8.41h.005a.191.191 0 01.255.228c-.122.463-.092.953.085 1.398.221.558.654 1.005 1.205 1.244.282.122.585.185.892.184.29 0 .576-.055.846-.16l.134-.056a.213.213 0 01.238.054l1.522 1.678a.213.213 0 01-.02.306v-.004zm3.428-.3a.212.212 0 01-.17.208l-1.116.223a.209.209 0 01-.18-.046.213.213 0 01-.075-.17 1.728 1.728 0 00-.375-1.112l-.011-.013-2.244-2.468a.912.912 0 00-.953-.216l-.815.334a.553.553 0 01-.463-1.003l2.175-1.06c.264-.126.566-.145.843-.053l3.268 1.251a.17.17 0 01.11.162l.006 3.963z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$2d = /*#__PURE__*/React__namespace.forwardRef(SvgAgreement$1);

  function SvgBirthdayCake$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.273 7.125c.434-.001.85-.18 1.158-.498a1.72 1.72 0 00.478-1.196 4.666 4.666 0 00-.925-2.093.912.912 0 00-1.423 0 4.66 4.66 0 00-.925 2.093c0 .448.172.878.479 1.196.307.317.723.497 1.158.498zM16.727 7.125c.435-.001.851-.18 1.158-.498a1.72 1.72 0 00.479-1.196 4.668 4.668 0 00-.925-2.093.912.912 0 00-1.423 0 4.66 4.66 0 00-.925 2.093c0 .448.172.878.478 1.196.307.317.724.497 1.158.498zM12 7.125c.435-.001.851-.18 1.158-.498a1.72 1.72 0 00.478-1.196 4.666 4.666 0 00-.925-2.093.912.912 0 00-1.423 0 4.66 4.66 0 00-.924 2.093c0 .448.171.878.478 1.196.307.317.723.497 1.158.498zM18.182 11.25a.358.358 0 01-.257-.11.38.38 0 01-.107-.265v-2.25a.762.762 0 00-.213-.53.716.716 0 00-.514-.22h-.727a.716.716 0 00-.515.22.762.762 0 00-.213.53v2.25a.38.38 0 01-.106.265.358.358 0 01-.257.11h-1.819a.358.358 0 01-.257-.11.38.38 0 01-.106-.265v-2.25a.762.762 0 00-.213-.53.716.716 0 00-.514-.22h-.728a.716.716 0 00-.514.22.762.762 0 00-.213.53v2.25a.38.38 0 01-.106.265.358.358 0 01-.258.11H8.728a.358.358 0 01-.257-.11.38.38 0 01-.106-.265v-2.25a.762.762 0 00-.213-.53.716.716 0 00-.515-.22H6.91a.716.716 0 00-.514.22.762.762 0 00-.213.53v2.25a.38.38 0 01-.107.265.358.358 0 01-.257.11 1.79 1.79 0 00-1.285.55A1.905 1.905 0 004 13.124v.27c0 .362.13.712.367.981.236.27.56.438.91.474.298.032.598-.02.868-.15s.502-.333.67-.588a.971.971 0 01.345-.325.993.993 0 01.94.002c.15.081.278.2.372.344.15.224.352.407.586.533a1.599 1.599 0 001.519 0c.234-.126.435-.31.586-.533.097-.134.223-.243.369-.317a1.02 1.02 0 011.304.317c.15.224.352.407.586.533a1.599 1.599 0 001.518 0c.235-.126.436-.31.587-.533.093-.145.22-.264.37-.345a.982.982 0 01.487-.12c.159 0 .314.041.454.119.14.077.258.189.346.325.167.255.399.458.67.588.27.13.57.182.867.15.35-.036.675-.204.912-.473a1.49 1.49 0 00.367-.983v-.269c0-.497-.192-.974-.532-1.326a1.79 1.79 0 00-1.286-.549zM19.503 15.802a2.452 2.452 0 01-.671.168 2.67 2.67 0 01-1.198-.15 2.738 2.738 0 01-1.02-.663.362.362 0 00-.262-.11.353.353 0 00-.258.115c-.25.263-.548.47-.877.613-.33.141-.683.213-1.04.212-.72 0-1.41-.295-1.92-.82a.358.358 0 00-.514 0 2.686 2.686 0 01-1.925.82 2.686 2.686 0 01-1.926-.82.358.358 0 00-.509 0 2.745 2.745 0 01-1.019.659c-.382.139-.79.19-1.193.147a2.444 2.444 0 01-.671-.168.354.354 0 00-.339.037.37.37 0 00-.161.309v2.974c0 .246.047.49.138.718.092.227.226.434.395.608.168.174.369.312.59.406.22.095.456.143.695.143h12.364c.239 0 .475-.049.696-.143.22-.094.42-.232.59-.406a1.88 1.88 0 00.394-.608c.091-.228.138-.472.138-.718v-2.974a.384.384 0 00-.159-.31.356.356 0 00-.338-.04z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$2c = /*#__PURE__*/React__namespace.forwardRef(SvgBirthdayCake$1);

  function SvgBrowserUrl$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.689 18.762A1.69 1.69 0 013 17.073V4.69A1.69 1.69 0 014.689 3h13.51a1.69 1.69 0 011.689 1.689v4.503a.563.563 0 01-1.126 0V7.503H4.126v9.57c0 .311.252.563.563.563h4.503a.563.563 0 010 1.126H4.69zM18.762 6.378v-1.69a.563.563 0 00-.563-.562H4.69a.563.563 0 00-.563.563v1.689h14.636z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.18 21.003a2.36 2.36 0 01-1.653-.756 2.385 2.385 0 01-.001-3.237l.984-.985a2.258 2.258 0 011.875-.644.564.564 0 01-.133 1.118 1.136 1.136 0 00-.949.324l-.967.968a1.248 1.248 0 00.884 2.087h.048c.315 0 .617-.118.849-.334l.954-.956c.25-.252.37-.613.32-.966a.559.559 0 01.11-.417.558.558 0 01.45-.223c.279 0 .518.208.556.485a2.29 2.29 0 01-.637 1.915l-.971.971a2.386 2.386 0 01-1.718.65zM17.777 16.53c-.103 0-.208-.007-.31-.021a.562.562 0 11.156-1.115 1.165 1.165 0 00.968-.322l.967-.968c.214-.232.33-.548.316-.882a1.247 1.247 0 00-1.25-1.197c-.318 0-.619.117-.848.329l-.948.953c-.249.25-.366.594-.324.944a.565.565 0 01-.557.631.566.566 0 01-.56-.493 2.258 2.258 0 01.642-1.876l.965-.97a2.393 2.393 0 013.241-.016c.466.43.738 1.017.763 1.65a2.36 2.36 0 01-.628 1.708l-.985.985c-.425.42-1.01.66-1.608.66z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.258 18.2a.564.564 0 01-.398-.961l3.378-3.379a.558.558 0 01.796 0c.219.22.219.577 0 .796l-3.378 3.378a.557.557 0 01-.398.165z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$2b = /*#__PURE__*/React__namespace.forwardRef(SvgBrowserUrl$1);

  function SvgCamera$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.005 9.056c.28.155.602.244.945.244h.45v.45a1.95 1.95 0 103.9 0V9.3h.45a1.95 1.95 0 001.733-2.844c.046-.06.095-.13.151-.21l.151-.213c.852-1.177 1.323-1.825 2.215-1.825h4.165c1.157 0 1.69 1.123 2.204 2.209v.002a.445.445 0 00.401.288h1.096c1.76 0 2.13 1.007 2.13 1.852v8.653a1.878 1.878 0 01-2.13 1.99H4.134a1.877 1.877 0 01-2.13-1.99V9.056zm16.268 6.143a4.79 4.79 0 10-7.966-5.322 4.79 4.79 0 007.966 5.322zm-.859-2.661a3.124 3.124 0 11-6.247 0 3.124 3.124 0 016.247 0z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.35 3.85a1.1 1.1 0 00-1.1 1.1v1.3h-1.3a1.1 1.1 0 100 2.2h1.3v1.3a1.1 1.1 0 002.2 0v-1.3h1.3a1.1 1.1 0 000-2.2h-1.3v-1.3a1.1 1.1 0 00-1.1-1.1z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$2a = /*#__PURE__*/React__namespace.forwardRef(SvgCamera$1);

  function SvgCar$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.833 14.498a.208.208 0 00.209-.209v-1.875a1.667 1.667 0 011.666-1.666h.398a.209.209 0 00.187-.115l1.354-2.716A1.66 1.66 0 018.142 7h6.675a1.661 1.661 0 011.495.917l1.355 2.716a.21.21 0 00.186.115h2.48A1.666 1.666 0 0122 12.414v2.084a1.25 1.25 0 01-1.037 1.23.208.208 0 01-.242-.179 2.49 2.49 0 00-4.944.015.208.208 0 01-.207.184H9.472a.206.206 0 01-.207-.184 2.496 2.496 0 00-4.973.376.208.208 0 01-.209.224h-1.25a.833.833 0 110-1.667zm9.375-4.375a.208.208 0 00.209.208h2.896a.21.21 0 00.187-.302l-.626-1.25a.208.208 0 00-.186-.115h-2.271a.208.208 0 00-.209.209v1.25zm-4.743.11a.208.208 0 00.177.098h2.691a.208.208 0 00.209-.208v-1.25a.208.208 0 00-.209-.209H8.267a.208.208 0 00-.187.115l-.625 1.25a.21.21 0 00.01.204z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.25 17.53a1.667 1.667 0 110-3.333 1.667 1.667 0 010 3.334zM6.792 17.53a1.667 1.667 0 110-3.333 1.667 1.667 0 010 3.334z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$29 = /*#__PURE__*/React__namespace.forwardRef(SvgCar$1);

  function SvgDependente$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 9.5A3.75 3.75 0 1012 2a3.75 3.75 0 000 7.5zm-1.666-4.375h.625a.417.417 0 00.417-.417v-.625a.625.625 0 011.25 0v.625a.416.416 0 00.416.417h.625a.625.625 0 010 1.25h-.625a.417.417 0 00-.416.417v.625a.625.625 0 11-1.25 0v-.625a.417.417 0 00-.417-.417h-.625a.625.625 0 110-1.25zM9.79 18.486a.209.209 0 00-.054-.175 3.121 3.121 0 01-.78-2.822.416.416 0 00-.064-.322.193.193 0 01-.032-.098.208.208 0 01.083-.185 3.667 3.667 0 10-4.306 0 .209.209 0 01-.026.354A4.796 4.796 0 002 19.5a.417.417 0 00.416.417h5.394a.832.832 0 00.622-.28c.357-.401.78-.74 1.25-1a.207.207 0 00.107-.151zm-2.998-4.57a2 2 0 01-1.896-2.629.208.208 0 01.31-.11c.989.63 2.178.868 3.333.667a.21.21 0 01.229.127c.011.028.016.06.014.09a2 2 0 01-1.99 1.856zM19.334 15.474a.416.416 0 00-.524.174l-1.007 1.75a.21.21 0 01-.361 0l-1.007-1.75a.417.417 0 00-.524-.174c-.191.081-.376.176-.553.284a.478.478 0 00-.23.409 3.11 3.11 0 01-.857 2.146.209.209 0 00-.019.263.21.21 0 00.07.063c.468.26.889.599 1.245 1a.834.834 0 00.623.28h5.394a.416.416 0 00.417-.419 4.383 4.383 0 00-2.667-4.026zM12 19.083a3.743 3.743 0 00-3.47 2.345.416.416 0 00.387.572h6.206a.39.39 0 00.364-.533A3.744 3.744 0 0012 19.083z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.923 16.167a2.083 2.083 0 104.167 0 2.083 2.083 0 00-4.167 0zM14.084 11.777c.016.498-.07.994-.25 1.459a.417.417 0 00.122.491c.273.22.507.482.694.778a.22.22 0 00.366.012.206.206 0 01.23-.076.212.212 0 01.075.041 3.533 3.533 0 004.605 0 .212.212 0 01.305.035c.105.144.221.28.348.405a.834.834 0 101.172-1.184 2.557 2.557 0 01-.583-1.96 3.542 3.542 0 00-7.084 0zm1.853.023a2.84 2.84 0 00.757-.233c.3-.141.563-.353.764-.617a.209.209 0 01.333 0c.2.264.463.476.763.617.24.112.496.191.758.233a.208.208 0 01.166.232 1.875 1.875 0 01-3.718 0 .21.21 0 01.177-.232z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$28 = /*#__PURE__*/React__namespace.forwardRef(SvgDependente$1);

  function SvgEdit$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.666 11.573a.833.833 0 00-.833.834v7.083a.833.833 0 01-.833.833H4.5a.833.833 0 01-.833-.833V5.324A.833.833 0 014.5 4.49h8.333a.833.833 0 000-1.666H4.5a2.5 2.5 0 00-2.5 2.5V19.49a2.5 2.5 0 002.5 2.5H17a2.5 2.5 0 002.5-2.5v-7.083a.833.833 0 00-.834-.834zM21.512 2.482a1.707 1.707 0 00-2.357 0l-.884.884a.417.417 0 000 .59l1.768 1.767a.417.417 0 00.589 0l.884-.884a1.667 1.667 0 000-2.357z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.466 10.762l1.767 1.767a.417.417 0 00.59 0l5.302-5.303a.417.417 0 000-.59l-1.768-1.768a.43.43 0 00-.589 0l-5.302 5.304a.417.417 0 000 .59zM10.624 11.363a.422.422 0 00-.303.25l-1.01 2.529a.416.416 0 00.092.449.44.44 0 00.45.092l2.524-1.01a.416.416 0 00.14-.681L11 11.476a.417.417 0 00-.376-.114z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$27 = /*#__PURE__*/React__namespace.forwardRef(SvgEdit$1);

  function SvgFold$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.127 2H6.064A1.277 1.277 0 005 3.31v14.565a1.452 1.452 0 00.917 1.354l6.667 2.667a1.46 1.46 0 002-1.355V6.374a1.453 1.453 0 00-.917-1.355l-2.383-.952a.208.208 0 01.076-.4h6.558a.208.208 0 01.208.208v13.73a.208.208 0 01-.208.209H16.46a.833.833 0 000 1.666h1.667a1.667 1.667 0 001.667-1.666V3.667A1.667 1.667 0 0018.127 2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$26 = /*#__PURE__*/React__namespace.forwardRef(SvgFold$1);

  function SvgGenderFemale$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19 9.012a7 7 0 10-8.31 6.864.225.225 0 01.181.222v1.398a.226.226 0 01-.226.226H9.29a1.13 1.13 0 100 2.258h1.355a.226.226 0 01.226.225v1.355a1.129 1.129 0 102.258 0v-1.355a.225.225 0 01.226-.225h1.355a1.129 1.129 0 100-2.258h-1.355a.225.225 0 01-.226-.226v-1.394a.225.225 0 01.18-.221A7.006 7.006 0 0019 9.01zm-11.742 0a4.742 4.742 0 119.484 0 4.742 4.742 0 01-9.484 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$25 = /*#__PURE__*/React__namespace.forwardRef(SvgGenderFemale$1);

  function SvgGenderMale$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21 3.374A.374.374 0 0020.626 3H15.39a.374.374 0 00-.265.639l1.825 1.824a.188.188 0 01.041.204.189.189 0 01-.04.061l-3.332 3.33a.187.187 0 01-.241.02 6.569 6.569 0 101.543 1.543.187.187 0 01.02-.24l3.332-3.332a.187.187 0 01.264 0l1.824 1.825A.374.374 0 0021 8.61V3.374zM9.593 19.082a4.675 4.675 0 110-9.35 4.675 4.675 0 010 9.35z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$24 = /*#__PURE__*/React__namespace.forwardRef(SvgGenderMale$1);

  function SvgGlasses$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.457 4a.75.75 0 000 1.5A1.045 1.045 0 0119.5 6.543v5.574a.188.188 0 01-.294.155 4.153 4.153 0 00-5.827 1.12.375.375 0 01-.468.133 2.175 2.175 0 00-1.822 0 .375.375 0 01-.468-.133 4.152 4.152 0 00-5.827-1.12.187.187 0 01-.294-.155V6.543A1.045 1.045 0 015.543 5.5a.75.75 0 000-1.5A2.55 2.55 0 003 6.543v9.15a4.158 4.158 0 008.315 0v-.18a.684.684 0 111.37 0v.18a4.158 4.158 0 008.315 0v-9.15A2.55 2.55 0 0018.457 4zm-11.3 14.348a2.658 2.658 0 110-5.316 2.658 2.658 0 010 5.316zm9.686 0a2.658 2.658 0 11-.002-5.317 2.658 2.658 0 01.002 5.316z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$23 = /*#__PURE__*/React__namespace.forwardRef(SvgGlasses$1);

  function SvgHealthInsurance$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.125 12h-.833a.207.207 0 01-.148-.062.211.211 0 01-.06-.149v-.842a.636.636 0 00-.184-.446.622.622 0 00-.442-.185h-1.25a.622.622 0 00-.441.185.636.636 0 00-.184.446v.843a.207.207 0 01-.208.21h-.833a.622.622 0 00-.442.185.636.636 0 00-.183.447v1.263c0 .167.066.328.183.446a.622.622 0 00.442.185h.833a.212.212 0 01.208.21v.843c0 .167.066.328.184.446a.622.622 0 00.441.186h1.25a.622.622 0 00.442-.186.636.636 0 00.183-.446v-.842c0-.056.022-.11.061-.149a.207.207 0 01.148-.062h.833a.622.622 0 00.442-.185.636.636 0 00.183-.446v-1.263a.636.636 0 00-.183-.447.622.622 0 00-.442-.185z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M22 5.684c0-.446-.176-.875-.488-1.19A1.658 1.658 0 0020.333 4H3.667c-.442 0-.866.177-1.179.493A1.693 1.693 0 002 5.684v12.632c0 .447.176.875.488 1.19.313.317.737.494 1.179.494h16.666c.442 0 .866-.177 1.179-.493.312-.316.488-.745.488-1.191V5.684zM4.083 18.316a.415.415 0 01-.294-.123.423.423 0 01-.122-.298V9.053c0-.112.044-.22.122-.298a.414.414 0 01.294-.123h15.834c.11 0 .216.044.294.123a.423.423 0 01.122.298v8.842a.424.424 0 01-.122.297.415.415 0 01-.294.124H4.083z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.042 11.79h-3.959a.622.622 0 00-.442.184.635.635 0 00.442 1.079h3.959a.621.621 0 00.442-.186.634.634 0 00-.442-1.078zM17 14.316h-2.917a.622.622 0 00-.442.185.635.635 0 000 .893.622.622 0 00.442.185H17a.622.622 0 00.442-.185.635.635 0 000-.893.622.622 0 00-.442-.185z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$22 = /*#__PURE__*/React__namespace.forwardRef(SvgHealthInsurance$1);

  function SvgHyperlink$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.837 16.811l-2.066 2.065a2.153 2.153 0 01-2.975 0l-.673-.673a2.104 2.104 0 010-2.974L9.5 10.852a2.105 2.105 0 012.976 0l.673.673a.756.756 0 101.07-1.07l-.673-.673a3.616 3.616 0 00-5.11 0l-4.378 4.377a3.612 3.612 0 000 5.11l.673.672a3.61 3.61 0 005.11 0l2.066-2.064a.756.756 0 00-1.068-1.068l-.002.002z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.945 4.727l-.673-.673a3.623 3.623 0 00-5.11 0L11.97 6.243a.754.754 0 001.067 1.067l2.189-2.189a2.106 2.106 0 012.974 0l.674.674a2.104 2.104 0 010 2.975l-4.377 4.378a2.09 2.09 0 01-1.488.616 2.087 2.087 0 01-1.486-.616.756.756 0 00-1.25.232.754.754 0 00.182.834 3.586 3.586 0 002.554 1.057 3.587 3.587 0 002.555-1.057l4.377-4.377a3.612 3.612 0 000-5.11h.004z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$21 = /*#__PURE__*/React__namespace.forwardRef(SvgHyperlink$1);

  function SvgLock$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.526 9.197h-.552V7.114a5.187 5.187 0 00-1.457-3.616A4.906 4.906 0 0012 2c-1.32 0-2.584.539-3.517 1.498a5.188 5.188 0 00-1.457 3.616v2.083h-.552c-.391 0-.766.16-1.042.444-.277.284-.432.67-.432 1.071v9.773c0 .402.155.787.432 1.071.276.284.65.444 1.042.444h11.052c.391 0 .766-.16 1.042-.444.277-.284.432-.67.432-1.071v-9.773c0-.402-.155-.787-.432-1.071a1.454 1.454 0 00-1.042-.444zm-7 5.455a1.548 1.548 0 01.195-.76c.128-.23.314-.423.538-.557a1.443 1.443 0 011.475-.004c.225.132.411.324.541.554a1.548 1.548 0 01.002 1.517c-.13.23-.316.422-.54.555v1.725c0 .2-.078.393-.216.536a.727.727 0 01-.521.221.727.727 0 01-.521-.221.769.769 0 01-.216-.536v-1.725a1.49 1.49 0 01-.538-.551c-.13-.23-.198-.49-.199-.755zM8.868 7.114c0-.854.33-1.673.918-2.277A3.089 3.089 0 0112 3.894c.83 0 1.627.34 2.214.943.588.604.918 1.423.918 2.277v1.704c0 .1-.04.197-.108.268a.363.363 0 01-.26.111H9.236a.363.363 0 01-.26-.111.384.384 0 01-.109-.268V7.114z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$20 = /*#__PURE__*/React__namespace.forwardRef(SvgLock$1);

  function SvgMail$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21.907 6.603a.145.145 0 00-.167.034l-8.122 8.527a2.237 2.237 0 01-1.62.704c-.608 0-1.19-.253-1.62-.704l-8.12-8.527a.143.143 0 00-.167-.034.154.154 0 00-.066.059A.165.165 0 002 6.75v10.5c0 .464.176.91.488 1.237.313.329.737.513 1.179.513h16.666c.442 0 .866-.184 1.179-.513.312-.328.488-.773.488-1.237V6.75a.164.164 0 00-.025-.089.153.153 0 00-.068-.058z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.262 14.236c.196.205.46.32.737.32.276 0 .541-.115.737-.32l8.071-8.475a.459.459 0 00.1-.447c-.09-.288-.345-.314-.574-.314H3.667c-.23 0-.486.026-.576.314a.458.458 0 00.1.447l8.071 8.476z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1$ = /*#__PURE__*/React__namespace.forwardRef(SvgMail$1);

  function SvgPhone$3(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.825 3.69a34.063 34.063 0 00-13.65 0A2.775 2.775 0 003 6.309v1.5a1.875 1.875 0 001.875 1.875h2.25A1.875 1.875 0 009 7.808V7.2a.19.19 0 01.174-.19 34.025 34.025 0 015.652 0A.19.19 0 0115 7.2v.609a1.875 1.875 0 001.875 1.875h2.25A1.875 1.875 0 0021 7.809v-1.5a2.775 2.775 0 00-2.175-2.618zM7.875 13.5a1.312 1.312 0 100-2.624 1.312 1.312 0 000 2.625zM7.875 17.25a1.312 1.312 0 100-2.624 1.312 1.312 0 000 2.625zM7.875 21a1.312 1.312 0 100-2.625 1.312 1.312 0 000 2.625zM12 13.5a1.312 1.312 0 100-2.624 1.312 1.312 0 000 2.625zM12 17.25a1.312 1.312 0 100-2.624 1.312 1.312 0 000 2.625zM12 21a1.312 1.312 0 100-2.625A1.312 1.312 0 0012 21zM16.125 13.5a1.312 1.312 0 100-2.624 1.312 1.312 0 000 2.625zM16.125 17.25a1.312 1.312 0 100-2.624 1.312 1.312 0 000 2.625zM16.125 21a1.312 1.312 0 100-2.625 1.312 1.312 0 000 2.625z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1_ = /*#__PURE__*/React__namespace.forwardRef(SvgPhone$3);

  function SvgPin$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a7.03 7.03 0 00-4.947 2.04A6.943 6.943 0 005 8.957c0 3.052 4.375 9.587 6.255 12.63A.873.873 0 0012 22a.871.871 0 00.745-.415C14.625 18.545 19 12.012 19 8.957a6.943 6.943 0 00-2.053-4.917A7.03 7.03 0 0012 2zm0 10a3.076 3.076 0 01-1.701-.513 3.048 3.048 0 01-1.128-1.366 3.026 3.026 0 01.663-3.317 3.08 3.08 0 013.338-.66c.56.231 1.038.621 1.374 1.122a3.03 3.03 0 01-.38 3.843A3.072 3.072 0 0112 12z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1Z = /*#__PURE__*/React__namespace.forwardRef(SvgPin$1);

  function SvgQuestionCircle$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm0 15.833a1.25 1.25 0 110-2.501 1.25 1.25 0 010 2.501zm1.333-5.066a.834.834 0 00-.5.764.834.834 0 01-1.666 0 2.5 2.5 0 011.5-2.292 1.667 1.667 0 10-2.334-1.527.834.834 0 01-1.666 0 3.333 3.333 0 114.666 3.056v-.001z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1Y = /*#__PURE__*/React__namespace.forwardRef(SvgQuestionCircle$1);

  function SvgQuit$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.134 16.875a.75.75 0 00-.75.75V18a.375.375 0 01-.376.375h-4.127a.375.375 0 01-.376-.375V6a.375.375 0 01.375-.375h4.128a.375.375 0 01.376.375v.75a.75.75 0 101.5 0V4.875a.75.75 0 00-.75-.75h-5.629v-.75a.374.374 0 00-.456-.366l-6.755 1.5A.375.375 0 004 4.875v14.25a.375.375 0 00.294.367l6.755 1.5a.381.381 0 00.42-.206.375.375 0 00.036-.162v-.75h5.63a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75zm-7.505-4.5a1.124 1.124 0 01-1.922.795A1.124 1.124 0 119.3 11.58c.211.21.33.496.33.795z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21.666 11.75l-3.659-2.437a.75.75 0 00-1.166.624v1.313h-3.096a1.126 1.126 0 100 2.25h3.096v1.312a.75.75 0 001.166.624L21.666 13a.75.75 0 000-1.248z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1X = /*#__PURE__*/React__namespace.forwardRef(SvgQuit$1);

  function SvgShare$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M110.833 81.667a29.027 29.027 0 00-20.918 8.925L57.872 74.567A28.863 28.863 0 0058.333 70a28.787 28.787 0 00-.46-4.567l32.042-16.025a29.114 29.114 0 10-8.248-20.241 28.863 28.863 0 00.46 4.573L50.085 49.752a29.167 29.167 0 100 40.49l32.042 16.018a28.787 28.787 0 00-.46 4.573 29.167 29.167 0 1029.166-29.166z"
    }));
  }

  var ForwardRef$1W = /*#__PURE__*/React__namespace.forwardRef(SvgShare$1);

  function SvgSyringe$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      viewBox: "0 0 140 140",
      height: "1em",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M107.287 40.962a2.917 2.917 0 013.225-.613A19.746 19.746 0 00118.417 42 20.417 20.417 0 1098 21.583a19.746 19.746 0 001.674 7.881 2.917 2.917 0 01-.583 3.226l-7.881 7.852a2.917 2.917 0 01-4.124 0l-1.266-1.266a2.917 2.917 0 01-.618-3.22 19.763 19.763 0 001.668-7.881 20.282 20.282 0 00-5.98-14.437 20.918 20.918 0 00-28.868 0 20.277 20.277 0 00-5.985 14.437 5.833 5.833 0 1011.666 0 8.662 8.662 0 012.567-6.183 8.954 8.954 0 0112.373 0 8.75 8.75 0 010 12.355l-19.42 19.436-28.875 28.87a23.287 23.287 0 00-4.491 26.494 2.917 2.917 0 01-.584 3.32L2.917 128.853a5.833 5.833 0 008.23 8.23l16.38-16.333a2.917 2.917 0 013.331-.583 23.246 23.246 0 0026.49-4.504l28.869-28.875 19.43-19.425a8.75 8.75 0 116.178 14.951 5.833 5.833 0 000 11.667 20.382 20.382 0 10-7.887-39.148 2.917 2.917 0 01-3.196-.624l-1.284-1.283a2.917 2.917 0 010-4.124zm11.13-28.129a8.75 8.75 0 11-8.75 8.75 8.75 8.75 0 018.75-8.75zM91.233 61.14a2.917 2.917 0 010 4.124l-7.076 7.07a2.917 2.917 0 01-4.124 0l-6.189-6.183-6.177-6.183a2.917 2.917 0 010-4.125l7.058-7.058a2.917 2.917 0 014.124 0z"
    }));
  }

  var ForwardRef$1V = /*#__PURE__*/React__namespace.forwardRef(SvgSyringe$1);

  function SvgTerms$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.125 3H4.875A1.875 1.875 0 003 4.875v14.25A1.875 1.875 0 004.875 21h14.25A1.875 1.875 0 0021 19.125V4.875A1.875 1.875 0 0019.125 3zm-2.25 7.125H13.5a.75.75 0 110-1.5h3.375a.75.75 0 110 1.5zm.75 6a.75.75 0 01-.75.75H13.5a.75.75 0 110-1.5h3.375a.75.75 0 01.75.75zM11.475 7.2l-2.25 3a.75.75 0 01-.547.3h-.053a.75.75 0 01-.53-.22L6.97 9.155a.75.75 0 011.06-1.061l.514.514L10.275 6.3a.75.75 0 111.2.9zm0 7.5l-2.25 3a.763.763 0 01-1.13.08L6.97 16.655a.75.75 0 011.06-1.06l.514.513 1.731-2.308a.75.75 0 011.2.9z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1U = /*#__PURE__*/React__namespace.forwardRef(SvgTerms$1);

  function SvgTextBalloon$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.5 4h-15A1.5 1.5 0 003 5.5v10.164a1.465 1.465 0 001.5 1.461h1.875v2.625a.75.75 0 001.177.617l4.682-3.242H19.5a1.5 1.5 0 001.5-1.5V5.5A1.5 1.5 0 0019.5 4zm0 11.438a.188.188 0 01-.188.187H12a.75.75 0 00-.427.133l-3.698 2.56v-1.943a.75.75 0 00-.75-.75H4.687a.188.188 0 01-.187-.188v-9.75a.187.187 0 01.188-.187h14.625a.188.188 0 01.187.188v9.75z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.5 9.625h9a.75.75 0 100-1.5h-9a.75.75 0 000 1.5zM7.5 13h9a.75.75 0 100-1.5h-9a.75.75 0 100 1.5z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1T = /*#__PURE__*/React__namespace.forwardRef(SvgTextBalloon$1);

  function SvgTime$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm4.333 14.35a.847.847 0 01-1.177.052l-4.133-3.788A.835.835 0 0110.75 12V7.417a.833.833 0 111.667 0v4.216l3.861 3.54a.833.833 0 01.055 1.179v-.001z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1S = /*#__PURE__*/React__namespace.forwardRef(SvgTime$1);

  function SvgUser$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 11.8c2.398 0 4.342-1.97 4.342-4.4C16.342 4.97 14.398 3 12 3 9.602 3 7.658 4.97 7.658 7.4c0 2.43 1.944 4.4 4.342 4.4zM12 13a7.459 7.459 0 00-5.3 2.229A7.66 7.66 0 004.5 20.6c0 .106.042.208.116.283a.392.392 0 00.279.117h14.21a.392.392 0 00.28-.117.403.403 0 00.115-.283 7.66 7.66 0 00-2.2-5.371A7.46 7.46 0 0012 13z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1R = /*#__PURE__*/React__namespace.forwardRef(SvgUser$1);

  function SvgUserId$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M22 5.667A1.667 1.667 0 0020.333 4H3.667A1.667 1.667 0 002 5.667v12.5a1.667 1.667 0 001.667 1.666h2.5A.834.834 0 007 19v-.625a.625.625 0 01.625-.625.634.634 0 01.625.625V19a.833.833 0 00.833.833h5.834A.834.834 0 0015.75 19v-.625a.624.624 0 01.625-.625.634.634 0 01.625.625V19a.833.833 0 00.833.833h2.5A1.667 1.667 0 0022 18.167v-12.5zM20.333 17.75a.417.417 0 01-.416.417h-.907a.417.417 0 01-.405-.321 2.292 2.292 0 00-4.46 0 .417.417 0 01-.405.32h-3.48a.417.417 0 01-.405-.32 2.292 2.292 0 00-4.46 0 .416.416 0 01-.405.32h-.907a.416.416 0 01-.416-.416V6.083a.417.417 0 01.416-.416h15.834a.417.417 0 01.416.416V17.75z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.875 11.5a.624.624 0 00.625.625h3.986a.625.625 0 100-1.25H14.5a.624.624 0 00-.625.625zM13.875 14a.624.624 0 00.625.625h2.174a.625.625 0 100-1.25H14.5a.624.624 0 00-.625.625zM14.5 9.625h4.167a.625.625 0 000-1.25H14.5a.625.625 0 100 1.25zM8.525 11.083a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333zM6.172 14.417h4.706a.418.418 0 00.393-.57 3 3 0 00-2.746-1.93 3 3 0 00-2.745 1.93.417.417 0 00.392.57z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1Q = /*#__PURE__*/React__namespace.forwardRef(SvgUserId$1);

  function SvgUserSquare$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.775 19.5l-3.9.03a.375.375 0 01-.375-.376V15.23a.75.75 0 10-1.5 0v4.303A1.47 1.47 0 004.468 21h4.307a.75.75 0 100-1.5zM3.75 9.525a.75.75 0 00.75-.75l-.03-3.9a.375.375 0 01.375-.375h3.93a.75.75 0 000-1.5H4.468A1.47 1.47 0 003 4.468v4.307a.75.75 0 00.75.75zM20.25 14.479a.75.75 0 00-.75.75l.03 3.893a.375.375 0 01-.375.375h-3.93a.75.75 0 100 1.5h4.304A1.47 1.47 0 0021 19.532V15.23a.75.75 0 00-.75-.75zM19.532 3h-4.307a.75.75 0 000 1.5l3.9-.03a.375.375 0 01.375.376v3.929a.75.75 0 001.5 0V4.468A1.47 1.47 0 0019.532 3zM7.505 16.374a.79.79 0 00.783.876h7.575a.635.635 0 00.462-.2.627.627 0 00.175-.475 4.517 4.517 0 00-8.993-.202l-.002.001zM11.993 11.625a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1P = /*#__PURE__*/React__namespace.forwardRef(SvgUserSquare$1);

  function SvgWhatsapp$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a9.963 9.963 0 00-7.045 2.923A10.11 10.11 0 002 11.997a9.904 9.904 0 001.783 5.683l-1.125 3.357a.423.423 0 00.525.538l3.5-1.117a9.941 9.941 0 0010.125.3 10.032 10.032 0 003.78-3.669c.912-1.54 1.4-3.298 1.412-5.092a10.11 10.11 0 00-2.955-7.074A9.963 9.963 0 0012 2zm6 14.035c-.279.534-.699.98-1.213 1.29-.515.31-1.104.47-1.704.464a8.878 8.878 0 01-2.875-.84 11.692 11.692 0 01-4.958-4.33c-1.592-2.124-1.667-4.114-.133-5.759a1.805 1.805 0 011.55-.47 1.278 1.278 0 011.008.73l.317.773.525 1.267a.93.93 0 010 .84 4.315 4.315 0 01-.834 1.15c.428.656.929 1.261 1.492 1.804a7.538 7.538 0 002.275 1.368c.233-.302.692-.84.833-1.066a.834.834 0 011.117-.302c.317.118 2.092.99 2.092.99.225.078.422.22.566.412A1.688 1.688 0 0118 16.035z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1O = /*#__PURE__*/React__namespace.forwardRef(SvgWhatsapp$1);

  function SvgWifi$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M23.602 57.85a7.292 7.292 0 0010.313 10.307 51.112 51.112 0 0172.182 0 7.28 7.28 0 005.156 2.135 7.233 7.233 0 007.263-7.123V63a7.245 7.245 0 00-2.135-5.15 65.707 65.707 0 00-92.78 0z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M132.907 35.513a89.07 89.07 0 00-125.814 0 7.293 7.293 0 0010.314 10.314 74.474 74.474 0 01105.186 0 7.293 7.293 0 0010.314-10.314zM83.9 70.192a42.303 42.303 0 00-43.802 9.981 7.292 7.292 0 005.151 12.449 7.274 7.274 0 005.157-2.141 27.697 27.697 0 0138.074-.904c.362.32.764.583 1.108.904a7.274 7.274 0 005.14 2.123 7.297 7.297 0 005.15-12.454 41.93 41.93 0 00-15.977-9.958zM55.417 115.914a14.583 14.583 0 1029.166 0 14.583 14.583 0 10-29.166 0z"
    }));
  }

  var ForwardRef$1N = /*#__PURE__*/React__namespace.forwardRef(SvgWifi$1);

  function SvgAgreement(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M118.358 83.65l-30.1 5.752M84.093 49.455l-20.23 6.685a6.714 6.714 0 01-8.196-3.564 6.79 6.79 0 013.086-8.925l19.594-9.853a13.667 13.667 0 0110.856-.63l29.01 10.611",
      strokeWidth: 8.749995
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21.496 83.697h14.262l20.487 22.96A7.828 7.828 0 0070 101.547v-3.588l1.02.409a9.66 9.66 0 0013.248-8.966h2.853a8.563 8.563 0 006.848-13.697L75.66 52.243M61.734 42.146l-2.088-1.721a12.25 12.25 0 00-7.263-2.386 12.14 12.14 0 00-4.544.881L21.875 49.303",
      strokeWidth: 8.749995
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.375 39.375h11.667a5.606 5.606 0 015.833 5.343v37.433a5.612 5.612 0 01-5.833 5.349H4.375M135.625 87.5h-11.667a5.612 5.612 0 01-5.833-5.35V44.719a5.606 5.606 0 015.833-5.343h11.667M70 97.96l-5.705-5.706M84.268 89.402l-8.563-8.564",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$1M = /*#__PURE__*/React__namespace.forwardRef(SvgAgreement);

  function SvgBirthdayCake(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.846 21C4.828 21 4 20.135 4 19.07v-6.428c0-1.064.828-1.929 1.846-1.929h.616V9.428a.63.63 0 01.615-.642.63.63 0 01.615.643v1.285h3.693V9.428A.63.63 0 0112 8.787a.63.63 0 01.615.643v1.285h3.693V9.428a.63.63 0 01.615-.642.63.63 0 01.616.643v1.285h.615c1.018 0 1.846.865 1.846 1.929v6.428C20 20.135 19.172 21 18.154 21H5.846zm-.615-1.929a.63.63 0 00.615.643h12.308a.63.63 0 00.615-.643v-2.414a2.665 2.665 0 01-3.384-.256c-.14.132-.293.25-.458.35-.42.256-.899.392-1.384.392-.689 0-1.347-.268-1.85-.742a2.668 2.668 0 01-1.843.742h-.047a2.646 2.646 0 01-1.497-.489c-.455.317-.993.49-1.538.49-.557-.001-1.087-.17-1.536-.485v2.412H5.23zm3.077-3.893c.165 0 .326.071.441.196a1.49 1.49 0 001.073.483h.046c.383 0 .753-.16 1.04-.45.098-.101.184-.215.254-.34a.613.613 0 01.531-.317c.218 0 .422.122.532.319.271.486.777.788 1.318.788.267 0 .531-.074.764-.217.226-.138.415-.336.547-.572a.614.614 0 01.53-.318c.219 0 .422.121.532.317.274.487.781.79 1.325.79.271 0 .539-.077.773-.221.468-.287.758-.818.756-1.384v-1.61a.63.63 0 00-.615-.642H5.847a.63.63 0 00-.615.643v1.607c-.001.428.158.832.448 1.136a1.488 1.488 0 002.187-.014.609.609 0 01.44-.194zM12 7.5c-1.018 0-1.846-.865-1.846-1.929 0-.914 1.089-2.064 1.423-2.394a.598.598 0 01.846 0c.334.33 1.423 1.479 1.423 2.394 0 1.064-.828 1.929-1.846 1.929zm0-2.926c-.418.501-.615.88-.615.997a.63.63 0 00.615.643.63.63 0 00.615-.643c0-.116-.197-.497-.615-.997zM16.923 7.5c-1.018 0-1.846-.865-1.846-1.929 0-.915 1.089-2.064 1.423-2.394a.598.598 0 01.846-.001c.334.33 1.423 1.48 1.423 2.395 0 1.064-.828 1.929-1.846 1.929zm0-2.927c-.418.501-.615.881-.615.998a.63.63 0 00.615.643.63.63 0 00.615-.643c0-.117-.197-.497-.615-.998zM7.077 7.5c-1.018 0-1.846-.865-1.846-1.929 0-.914 1.089-2.064 1.422-2.394a.598.598 0 01.847 0c.334.33 1.423 1.48 1.423 2.394 0 1.064-.828 1.929-1.846 1.929zm0-2.927c-.419.501-.616.882-.616.998a.63.63 0 00.616.643.63.63 0 00.615-.643c0-.117-.197-.497-.615-.998z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1L = /*#__PURE__*/React__namespace.forwardRef(SvgBirthdayCake);

  function SvgBrowserUrl(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.11 11.834l-.887.894a.75.75 0 00-.17.824.751.751 0 00.697.466.744.744 0 00.53-.23l.886-.893a1.36 1.36 0 011.93 0 1.376 1.376 0 010 1.94l-.888.893a.751.751 0 00.813 1.229.745.745 0 00.242-.168l.887-.893a2.874 2.874 0 00.85-2.035 2.886 2.886 0 00-.837-2.04 2.855 2.855 0 00-2.03-.841 2.842 2.842 0 00-2.023.854zM15.783 18.167l-.938.943a1.36 1.36 0 01-1.93 0 1.376 1.376 0 010-1.94l.938-.943a.753.753 0 00-.53-1.272.744.744 0 00-.525.21l-.938.944a2.881 2.881 0 00.013 4.05 2.85 2.85 0 004.027.013l.938-.944a.753.753 0 00-.53-1.271.744.744 0 00-.525.21z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.771 14.227a.744.744 0 00-1.055 0l-2.638 2.656a.753.753 0 00.236 1.235.743.743 0 00.819-.174l2.638-2.652a.751.751 0 000-1.065zM8.609 16.883h-3.37a.752.752 0 01-.746-.75V6.94a.188.188 0 01.186-.189h14.554a.186.186 0 01.186.188v2.45a.752.752 0 00.74.758.752.752 0 00.753-.744V5.25c0-.597-.236-1.17-.656-1.592-.42-.422-.99-.659-1.583-.659H5.239c-.594 0-1.163.237-1.583.66C3.236 4.081 3 4.653 3 5.25v10.882c0 .597.236 1.17.656 1.592.42.422.99.66 1.583.66h3.374a.753.753 0 00-.004-1.5zm1.593-12.382a.724.724 0 01.634-.38.718.718 0 01.635.38.73.73 0 01.115.375.732.732 0 01-.115.375.724.724 0 01-.635.38.719.719 0 01-.634-.38.74.74 0 01-.114-.375.737.737 0 01.114-.375zm-2.612 0a.724.724 0 01.634-.38.719.719 0 01.635.38.73.73 0 01.115.375.732.732 0 01-.115.375.724.724 0 01-.635.38.719.719 0 01-.634-.38.738.738 0 01-.114-.375.736.736 0 01.114-.375zm-2.658.068a.75.75 0 01.68-.443.73.73 0 01.635.375.73.73 0 01.114.375.732.732 0 01-.114.375.724.724 0 01-.635.38.719.719 0 01-.634-.38.738.738 0 01-.114-.375.744.744 0 01.07-.306h-.002z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1K = /*#__PURE__*/React__namespace.forwardRef(SvgBrowserUrl);

  function SvgCalendar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M3 6.033a1.5 1.5 0 011.5-1.5h16a1.5 1.5 0 011.5 1.5V19.5a1.5 1.5 0 01-1.5 1.5h-16A1.5 1.5 0 013 19.5V6.033z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3 9.6h19M8.067 6.433V2M16.933 6.433V2",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  }

  var ForwardRef$1J = /*#__PURE__*/React__namespace.forwardRef(SvgCalendar);

  function SvgCamera(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.875 17.75c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-8.75a3.755 3.755 0 00-3.75 3.75 3.755 3.755 0 003.75 3.75 3.755 3.755 0 003.75-3.75A3.755 3.755 0 0013.875 9z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2 8.575v9.8c0 1.034.84 1.875 1.875 1.875h16.25c1.034 0 1.875-.84 1.875-1.875v-10c0-1.034-.84-1.875-1.875-1.875h-1.488l-.732-1.463A1.865 1.865 0 0016.227 4h-4.704c-.716 0-1.358.397-1.678 1.037L9.113 6.5c.16.244.187.536.187.85 0 .138-.018.272-.052.4H9.5a.622.622 0 00.56-.346l.903-1.808a.622.622 0 01.56-.346h4.704c.239 0 .453.133.56.345l.904 1.81c.107.212.32.345.559.345h1.875c.345 0 .625.28.625.625v10c0 .345-.28.625-.625.625H3.875a.625.625 0 01-.625-.625V8.9h-.3c-.358 0-.688-.121-.95-.325z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.6 4.95a.75.75 0 011.5 0V6.6h1.65a.75.75 0 110 1.5H6.1v1.65a.75.75 0 11-1.5 0V8.1H2.95a.75.75 0 110-1.5H4.6V4.95z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1I = /*#__PURE__*/React__namespace.forwardRef(SvgCamera);

  function SvgCar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.375 18.25c-.8 0-1.507-.512-1.768-1.25H8.143a1.883 1.883 0 01-1.768 1.25c-.8 0-1.507-.512-1.768-1.25h-.732A1.877 1.877 0 012 15.125v-1.25a3.134 3.134 0 012.726-3.1l1.369-2.738C6.415 7.397 7.058 7 7.773 7h6.583c.715 0 1.357.397 1.677 1.037l1.354 2.713h1.488A3.128 3.128 0 0122 13.875v1.25C22 16.159 21.16 17 20.125 17h-1.983a1.881 1.881 0 01-1.767 1.25zm0-2.5a.625.625 0 100 1.25.625.625 0 000-1.25zm-10 0a.625.625 0 100 1.25.625.625 0 000-1.25zm13.75 0c.345 0 .625-.28.625-.625v-1.25c0-1.034-.84-1.875-1.875-1.875H5.125c-1.034 0-1.875.84-1.875 1.875v1.25c0 .345.28.625.625.625h.732a1.883 1.883 0 011.768-1.25c.8 0 1.507.512 1.768 1.25h6.464a1.883 1.883 0 011.767-1.25c.8 0 1.507.512 1.768 1.25h1.983zm-4.135-5l-1.075-2.155a.62.62 0 00-.558-.345H7.773a.622.622 0 00-.559.346L6.136 10.75h9.854z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1H = /*#__PURE__*/React__namespace.forwardRef(SvgCar);

  function SvgDependente(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.177 52.5a17.5 17.5 0 1035 0 17.5 17.5 0 10-35 0zM45.19 83.125A26.25 26.25 0 004.429 105M131.303 105a26.25 26.25 0 00-40.764-21.875M87.552 52.5a17.5 17.5 0 1035 0 17.5 17.5 0 10-35 0zM87.552 52.5s0 21.875-13.125 21.875M122.552 52.5s0 21.875 13.125 21.875M52.553 105a13.125 13.125 0 1026.25 0 13.125 13.125 0 10-26.25 0zM88.41 135.625a26.25 26.25 0 00-45.46 0M48.178 21.875h35M65.677 4.375v35",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$1G = /*#__PURE__*/React__namespace.forwardRef(SvgDependente);

  function SvgEdit(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M76.096 82.46l-21.654 3.098 3.092-21.66L113.22 8.213a13.125 13.125 0 0118.562 18.562zM107.03 14.402l18.562 18.562",
      strokeWidth: 8.749995
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M109.375 83.125v43.75a8.75 8.75 0 01-8.75 8.75h-87.5a8.75 8.75 0 01-8.75-8.75v-87.5a8.75 8.75 0 018.75-8.75h43.75",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$1F = /*#__PURE__*/React__namespace.forwardRef(SvgEdit);

  function SvgExternalLink(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3 21L21 3M21 19.97V3H4.03",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  }

  var ForwardRef$1E = /*#__PURE__*/React__namespace.forwardRef(SvgExternalLink);

  function SvgFold(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.755 21c-.156 0-.31-.021-.46-.063l-8.033-2.232A1.725 1.725 0 014 17.052V4.72C4 3.772 4.772 3 5.721 3h11.477c.95 0 1.721.772 1.721 1.721v12.05c0 .95-.772 1.722-1.721 1.722h-1.722v.785c0 .46-.179.892-.504 1.217a1.712 1.712 0 01-1.217.505zM5.716 4.148a.575.575 0 00-.568.573V17.05c0 .256.173.482.42.55l8.034 2.232a.58.58 0 00.558-.147.57.57 0 00.169-.406V7.315a.574.574 0 00-.421-.552L5.85 4.16a.633.633 0 00-.127-.013h-.008zm11.482 13.197a.574.574 0 00.573-.574V4.721a.574.574 0 00-.573-.573H9.543l4.694 1.515c.724.2 1.238.88 1.24 1.651v10.03h1.72v.001z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1D = /*#__PURE__*/React__namespace.forwardRef(SvgFold);

  function SvgGenderFemale(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22.364a.637.637 0 01-.636-.637v-1.909h-1.91a.637.637 0 010-1.273h1.91v-2.574A6.989 6.989 0 015 9c0-3.86 3.14-7 7-7s7 3.14 7 7a6.989 6.989 0 01-6.364 6.971v2.575h1.91a.637.637 0 010 1.272h-1.91v1.91a.637.637 0 01-.636.636zm0-19.091A5.734 5.734 0 006.273 9 5.734 5.734 0 0012 14.727 5.734 5.734 0 0017.727 9 5.734 5.734 0 0012 3.273z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1C = /*#__PURE__*/React__namespace.forwardRef(SvgGenderFemale);

  function SvgGenderMale(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.19 21a6.152 6.152 0 01-4.379-1.81 6.19 6.19 0 010-8.751l.005-.005A6.151 6.151 0 019.19 8.626c1.455 0 2.852.507 3.963 1.432l5.925-5.933h-3.71a.563.563 0 110-1.125h5.066a.556.556 0 01.221.045.56.56 0 01.301.303.541.541 0 01.043.215v5.063a.563.563 0 01-1.126 0V4.923l-5.923 5.93a6.174 6.174 0 01-.379 8.337A6.161 6.161 0 019.191 21zm-3.587-9.762a5.066 5.066 0 00.005 7.157 5.038 5.038 0 003.583 1.48 5.038 5.038 0 003.584-1.48 5.066 5.066 0 000-7.16A5.037 5.037 0 009.192 9.75a5.036 5.036 0 00-3.589 1.487z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1B = /*#__PURE__*/React__namespace.forwardRef(SvgGenderMale);

  function SvgGlasses(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.063 19.75a3.955 3.955 0 01-3.894-3.375H10.83a3.954 3.954 0 01-3.894 3.375A3.942 3.942 0 013 15.812v-9A2.815 2.815 0 015.813 4h.562a.563.563 0 010 1.125h-.563a1.69 1.69 0 00-1.687 1.688v6.25a3.907 3.907 0 012.813-1.188 3.955 3.955 0 013.894 3.375h2.337a3.954 3.954 0 013.894-3.375c1.075 0 2.08.433 2.813 1.187v-6.25a1.69 1.69 0 00-1.689-1.687h-.562a.563.563 0 010-1.125h.563A2.815 2.815 0 0121 6.813v9a3.942 3.942 0 01-3.938 3.937zm0-6.75a2.815 2.815 0 00-2.813 2.813 2.815 2.815 0 002.813 2.812 2.815 2.815 0 002.812-2.813A2.815 2.815 0 0017.062 13zM6.938 13a2.815 2.815 0 00-2.813 2.813 2.815 2.815 0 002.813 2.812 2.815 2.815 0 002.812-2.813A2.815 2.815 0 006.937 13z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1A = /*#__PURE__*/React__namespace.forwardRef(SvgGlasses);

  function SvgGraph(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      viewBox: "0 0 140 140",
      height: "1em",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.94 137.083h134.167M26.25 110.833a2.917 2.917 0 00-2.917-2.916H11.667a2.917 2.917 0 00-2.917 2.916v26.25h17.5zM61.25 81.667a2.917 2.917 0 00-2.917-2.917H46.667a2.917 2.917 0 00-2.917 2.917v55.416h17.5zM96.25 93.333a2.917 2.917 0 00-2.917-2.916H81.667a2.917 2.917 0 00-2.917 2.916v43.75h17.5zM131.25 52.5a2.917 2.917 0 00-2.917-2.917h-11.666a2.917 2.917 0 00-2.917 2.917v84.583h17.5zM8.773 67.083a8.75 8.75 0 1017.5 0 8.75 8.75 0 10-17.5 0zM43.773 37.917a8.75 8.75 0 1017.5 0 8.75 8.75 0 10-17.5 0zM78.773 49.583a8.75 8.75 0 1017.5 0 8.75 8.75 0 10-17.5 0zM113.773 11.667a8.75 8.75 0 1017.5 0 8.75 8.75 0 10-17.5 0zM24.88 60.958l20.923-17.441M60.824 40.682l18.398 6.13M115.523 16.917L93.596 42.496",
      strokeWidth: 5.83333
    })));
  }

  var ForwardRef$1z = /*#__PURE__*/React__namespace.forwardRef(SvgGraph);

  function SvgHealthInsurance(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3.875 20C2.841 20 2 19.172 2 18.154V5.846C2 4.828 2.84 4 3.875 4h16.25C21.159 4 22 4.828 22 5.846v12.308C22 19.172 21.16 20 20.125 20H3.875zm-.625-1.846c0 .34.28.615.625.615h16.25a.62.62 0 00.625-.615v-9.23H3.25v9.23zm17.5-10.462V5.846a.62.62 0 00-.625-.615H3.875a.62.62 0 00-.625.615v1.846h17.5z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.875 12.615A.62.62 0 0113.25 12c0-.34.28-.615.625-.615h5A.62.62 0 0119.5 12a.62.62 0 01-.625.615h-5zM13.875 16.308a.62.62 0 01-.625-.616c0-.34.28-.615.625-.615h2.5a.62.62 0 01.625.615.62.62 0 01-.625.616h-2.5zM8.25 16.923a.62.62 0 01-.625-.615V14.46H5.75a.62.62 0 01-.625-.615c0-.34.28-.615.625-.615h1.875v-1.846c0-.34.28-.616.625-.616a.62.62 0 01.625.616v1.846h1.875a.62.62 0 01.625.615.62.62 0 01-.625.615H8.875v1.847a.62.62 0 01-.625.615z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1y = /*#__PURE__*/React__namespace.forwardRef(SvgHealthInsurance);

  function SvgHyperlink(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.373 19.624a4.345 4.345 0 01-3.094-1.28A4.345 4.345 0 012 15.252c0-1.17.454-2.269 1.28-3.094L7.256 8.18a4.346 4.346 0 013.097-1.283c1.169 0 2.266.453 3.09 1.276a4.355 4.355 0 01.449 5.67.627.627 0 01-.874.138.62.62 0 01-.249-.408.62.62 0 01.112-.465 3.11 3.11 0 00-.32-4.05 3.105 3.105 0 00-2.208-.912c-.838 0-1.623.326-2.213.916L4.163 13.04a3.129 3.129 0 000 4.42c.589.589 1.374.913 2.21.913.836 0 1.62-.324 2.21-.914l.777-.776a.62.62 0 01.883 0 .62.62 0 010 .883l-.777.777a4.338 4.338 0 01-3.093 1.28z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.644 16.73a4.345 4.345 0 01-3.09-1.28 4.353 4.353 0 01-.447-5.67.627.627 0 011.122.27.62.62 0 01-.112.465 3.11 3.11 0 00.32 4.05c.59.59 1.374.914 2.208.914.838-.001 1.622-.326 2.212-.917l3.978-3.978c.59-.59.915-1.375.915-2.21s-.325-1.62-.915-2.21a3.104 3.104 0 00-2.21-.914c-.836 0-1.621.324-2.21.914l-.626.625a.62.62 0 01-.883 0 .619.619 0 01-.183-.442c0-.167.065-.324.183-.442l.625-.625A4.347 4.347 0 0117.625 4c1.169 0 2.268.454 3.093 1.28A4.345 4.345 0 0122 8.374a4.345 4.345 0 01-1.282 3.093l-3.978 3.978a4.345 4.345 0 01-3.092 1.284h-.004z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1x = /*#__PURE__*/React__namespace.forwardRef(SvgHyperlink);

  function SvgLight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M43.756 70a26.25 26.25 0 1052.5 0 26.25 26.25 0 10-52.5 0zM70.006 8.75v17.5M70.006 113.75v17.5M131.256 70h-17.5M26.256 70h-17.5M113.313 26.693L100.94 39.066M39.066 100.94l-12.373 12.372M113.313 113.313L100.94 100.94M39.066 39.066L26.693 26.693",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$1w = /*#__PURE__*/React__namespace.forwardRef(SvgLight);

  function SvgLock(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.75 22C5.785 22 5 21.185 5 20.182V11.09c0-1.003.785-1.818 1.75-1.818h.583V6.848C7.333 4.175 9.427 2 12 2s4.667 2.175 4.667 4.848v2.425h.583c.965 0 1.75.815 1.75 1.818v9.09C19 21.186 18.215 22 17.25 22H6.75zm0-11.515a.595.595 0 00-.583.606v9.09c0 .335.261.607.583.607h10.5a.595.595 0 00.583-.606V11.09a.595.595 0 00-.583-.606H6.75zm8.75-1.212V6.848c0-2.004-1.57-3.636-3.5-3.636S8.5 4.844 8.5 6.848v2.425h7z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 17.152a.595.595 0 01-.583-.606V14.12c0-.334.261-.606.583-.606.322 0 .583.272.583.606v2.425a.595.595 0 01-.583.606z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1v = /*#__PURE__*/React__namespace.forwardRef(SvgLock);

  function SvgMail(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4 19c-1.103 0-2-.856-2-1.91V6.91a1.83 1.83 0 01.443-1.198l.02-.023A2.028 2.028 0 014 5h16a2.035 2.035 0 011.562.717l.016.022c.276.339.422.742.422 1.17v10.182C22 18.144 21.103 19 20 19H4zm-.667-1.91c0 .352.299.637.667.637h16c.368 0 .667-.285.667-.636V7.174l-6.468 5.748a3.737 3.737 0 01-2.199.713 3.737 3.737 0 01-2.2-.713L3.334 7.174v9.917zm7.28-5.177c.395.29.887.45 1.387.45s.991-.16 1.386-.45l6.32-5.641H4.293l6.321 5.641z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1u = /*#__PURE__*/React__namespace.forwardRef(SvgMail);

  function SvgPhone$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.5 10.771a1.69 1.69 0 01-1.688-1.688.563.563 0 00-.562-.562h-4.5a.563.563 0 00-.563.563A1.69 1.69 0 017.5 10.77H4.687A1.69 1.69 0 013 9.083v-.667A3.913 3.913 0 016.14 4.56 31.06 31.06 0 0111.994 4a31.113 31.113 0 015.923.572A3.915 3.915 0 0121 8.415v.668a1.69 1.69 0 01-1.688 1.687H16.5zm-2.25-3.375c.93 0 1.688.757 1.688 1.688 0 .31.251.562.562.562h2.813c.31 0 .562-.252.562-.563v-.667a2.798 2.798 0 00-2.17-2.738l-.027-.005a29.942 29.942 0 00-5.684-.547 29.965 29.965 0 00-5.7.55 2.8 2.8 0 00-2.169 2.74v.667c0 .31.252.562.563.562H7.5c.31 0 .563-.252.563-.562 0-.931.756-1.688 1.687-1.688h4.5v.001zM7.781 14.146a.844.844 0 100-1.688.844.844 0 000 1.688zM12 14.146a.844.844 0 100-1.687.844.844 0 000 1.687zM16.219 14.146a.845.845 0 010-1.688l.037.003h.009a.841.841 0 01.797.841.845.845 0 01-.843.844zM7.781 17.52a.844.844 0 100-1.687.844.844 0 000 1.688zM12 17.52a.844.844 0 100-1.686.844.844 0 000 1.687zM16.219 17.52a.845.845 0 010-1.687l.037.003h.009a.841.841 0 01.797.841.845.845 0 01-.843.844zM7.781 20.896a.844.844 0 100-1.688.844.844 0 000 1.688zM12 20.896a.844.844 0 100-1.687.844.844 0 000 1.687zM16.219 20.896a.842.842 0 110-1.688.845.845 0 010 1.688z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1t = /*#__PURE__*/React__namespace.forwardRef(SvgPhone$2);

  function SvgPin(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 13.086c-2.105 0-3.818-1.755-3.818-3.912C8.182 7.016 9.895 5.26 12 5.26s3.818 1.755 3.818 3.913c0 2.157-1.713 3.912-3.818 3.912zm0-6.521c-1.403 0-2.546 1.17-2.546 2.609 0 1.438 1.143 2.608 2.546 2.608 1.403 0 2.545-1.17 2.545-2.608 0-1.439-1.142-2.609-2.545-2.609z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.998 22a1.25 1.25 0 01-.701-.217 1.283 1.283 0 01-.358-.367c-.595-.919-1.909-2.46-3.427-5.151C5.845 12.978 5 10.593 5 9.174 5 5.218 8.14 2 12 2s7 3.218 7 7.174c0 1.418-.845 3.804-2.512 7.09-1.942 3.127-2.832 4.233-3.427 5.152a1.261 1.261 0 01-1.063.584zM12 3.304c-3.158 0-5.727 2.633-5.727 5.87 0 2.504 3.182 8.477 5.727 11.52 2.546-3.043 5.727-9.017 5.727-11.52 0-3.236-2.569-5.87-5.727-5.87z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1s = /*#__PURE__*/React__namespace.forwardRef(SvgPin);

  function SvgQuestionCircle(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 14.5a.625.625 0 01-.625-.625v-.838c0-.794.502-1.505 1.25-1.769a1.878 1.878 0 001.25-1.767c0-.501-.195-.972-.55-1.326A1.86 1.86 0 0012 7.625c-.5 0-.972.196-1.326.55a1.86 1.86 0 00-.549 1.325.626.626 0 01-1.25 0c0-.835.326-1.62.916-2.21A3.104 3.104 0 0112 6.377 3.129 3.129 0 0115.125 9.5a3.13 3.13 0 01-2.083 2.946.626.626 0 00-.417.589v.839c0 .345-.28.625-.625.625zM12 17.625a.937.937 0 100-1.875.937.937 0 000 1.875z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm0-18.75c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S16.825 3.25 12 3.25z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1r = /*#__PURE__*/React__namespace.forwardRef(SvgQuestionCircle);

  function SvgQuit(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.688 19.876a.563.563 0 010-1.125h3.375c.31 0 .563-.252.563-.563v-1.125a.563.563 0 011.125 0v1.125a1.69 1.69 0 01-1.688 1.688h-3.375zM19.188 8.625a.563.563 0 01-.562-.562V6.938a.563.563 0 00-.563-.563h-3.375a.563.563 0 010-1.125h3.375c.93 0 1.688.757 1.688 1.688v1.125c0 .31-.253.562-.563.562zM11.875 21c-.054 0-.108-.004-.16-.012l-6.749-.964A1.131 1.131 0 014 18.911V5.791c0-.528.374-.99.89-1.101l6.733-1.662A1.132 1.132 0 0113 4.125v15.75c0 .3-.118.584-.33.796-.213.212-.496.329-.796.329zM5.142 5.786l-.018.006.001 13.118 6.752.964-.002-15.75-6.733 1.662zM19.189 15.375a.562.562 0 01-.398-.96l1.29-1.29h-4.83a.563.563 0 010-1.125h4.829l-1.29-1.29a.557.557 0 01-.165-.398.561.561 0 01.96-.398l2.25 2.25a.566.566 0 01.163.424.612.612 0 01-.05.21.534.534 0 01-.08.125.334.334 0 01-.03.038l-2.25 2.25a.568.568 0 01-.4.164z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.907 12.844a.845.845 0 11.002-1.69.845.845 0 01-.002 1.69z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1q = /*#__PURE__*/React__namespace.forwardRef(SvgQuit);

  function SvgShare(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.75 65.625a21.875 21.875 0 1043.75 0 21.875 21.875 0 10-43.75 0zM87.5 35a21.875 21.875 0 1043.75 0 21.875 21.875 0 10-43.75 0zM87.5 105a21.875 21.875 0 1043.75 0 21.875 21.875 0 10-43.75 0zM51.018 57.697l37.964-14.764M50.196 75.413l39.608 19.805",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$1p = /*#__PURE__*/React__namespace.forwardRef(SvgShare);

  function SvgSyringe(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      viewBox: "0 0 140 140",
      height: "1em",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M46.048 111.055L27.487 92.493a8.75 8.75 0 010-12.378L80.08 27.528l30.917 30.916-52.588 52.593a8.75 8.75 0 01-12.36.018z",
      strokeWidth: 8.749995
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15.116 111.057L30.584 95.59l12.374 12.375-15.468 15.468zM5.833 132.708l15.47-15.47M70.8 18.247l49.495 49.495M89.36 36.806l21.656-21.655 12.374 12.375-21.655 21.655zM101.733 5.868l30.94 30.94M80.08 64.65l12.373 12.373M61.518 83.213l12.373 12.372",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$1o = /*#__PURE__*/React__namespace.forwardRef(SvgSyringe);

  function SvgTerms(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.688 21A1.69 1.69 0 013 19.312V4.688C3 3.757 3.757 3 4.688 3h14.625C20.242 3 21 3.757 21 4.688v14.625A1.69 1.69 0 0119.312 21H4.688zm0-16.875a.563.563 0 00-.563.563v14.625c0 .31.252.562.563.562h14.625c.31 0 .562-.252.562-.563V4.688a.563.563 0 00-.563-.562H4.688z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.625 11.438a.557.557 0 01-.398-.165l-2.25-2.25a.557.557 0 01-.165-.398c0-.15.059-.292.165-.398a.557.557 0 01.398-.165c.15 0 .292.059.397.165l1.792 1.791 2.986-3.98a.566.566 0 01.787-.113.56.56 0 01.112.788l-3.374 4.5a.562.562 0 01-.41.223l-.04.002zM13.688 9.75a.563.563 0 010-1.125h3.374a.563.563 0 010 1.125h-3.375zM8.625 18.188a.557.557 0 01-.398-.165l-2.25-2.25a.564.564 0 01.398-.961c.15 0 .292.058.397.165l1.792 1.791 2.986-3.981a.566.566 0 01.787-.113c.249.186.299.54.113.788l-3.375 4.5a.562.562 0 01-.45.226zM13.688 16.5a.563.563 0 010-1.125h3.374a.563.563 0 010 1.125h-3.375z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1n = /*#__PURE__*/React__namespace.forwardRef(SvgTerms);

  function SvgTextBalloon(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.938 20.5a.56.56 0 01-.563-.563v-2.812H4.687A1.69 1.69 0 013 15.437v-9.75C3 4.758 3.757 4 4.688 4h14.625C20.242 4 21 4.757 21 5.688v9.75a1.69 1.69 0 01-1.688 1.687h-7.687l-4.35 3.262a.565.565 0 01-.338.113zM4.688 5.125a.563.563 0 00-.563.563v9.75c0 .31.252.562.563.562h2.25c.31 0 .562.252.562.563v2.25l3.6-2.7a.565.565 0 01.338-.113h7.874c.311 0 .563-.252.563-.563v-9.75a.563.563 0 00-.563-.562H4.688z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.9 9.438c-.29 0-.525-.253-.525-.563 0-.31.235-.563.525-.563h9.45c.29 0 .525.253.525.563 0 .31-.235.563-.525.563H6.9zM7.031 12.813c-.362 0-.656-.252-.656-.563 0-.31.294-.562.656-.562h9.188c.362 0 .656.252.656.562 0 .31-.294.563-.656.563H7.03z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1m = /*#__PURE__*/React__namespace.forwardRef(SvgTextBalloon);

  function SvgTime(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.012 10.012 0 0012 2zm0 18.333A8.333 8.333 0 1120.333 12 8.342 8.342 0 0112 20.333z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.278 15.175l-3.861-3.54V7.416a.833.833 0 10-1.667 0V12a.834.834 0 00.27.615l4.133 3.787a.842.842 0 001.177-.05.833.833 0 00-.052-1.177z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1l = /*#__PURE__*/React__namespace.forwardRef(SvgTime);

  function SvgUser(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 12c-2.52 0-4.571-2.019-4.571-4.5S9.479 3 12 3c2.52 0 4.571 2.019 4.571 4.5S14.521 12 12 12zm0-7.875c-1.89 0-3.429 1.514-3.429 3.375 0 1.86 1.539 3.375 3.429 3.375s3.429-1.514 3.429-3.375c0-1.86-1.539-3.375-3.429-3.375zM19.429 21a.567.567 0 01-.572-.563c0-3.722-3.076-6.75-6.857-6.75s-6.857 3.028-6.857 6.75c0 .31-.256.563-.572.563A.567.567 0 014 20.437c0-4.342 3.589-7.875 8-7.875s8 3.533 8 7.875c0 .31-.256.563-.571.563z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1k = /*#__PURE__*/React__namespace.forwardRef(SvgUser);

  function SvgUserId(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.875 12.125a2.816 2.816 0 01-2.813-2.813A2.816 2.816 0 018.876 6.5a2.816 2.816 0 012.813 2.813 2.816 2.816 0 01-2.813 2.812zm0-4.375c-.862 0-1.563.7-1.563 1.563 0 .861.701 1.562 1.563 1.562s1.563-.7 1.563-1.563c0-.861-.701-1.562-1.563-1.562z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.125 16.5a.625.625 0 01-.625-.625A4.38 4.38 0 018.875 11.5a4.38 4.38 0 014.375 4.375c0 .345-.28.625-.625.625h-7.5zm6.812-1.25a3.15 3.15 0 00-3.062-2.5 3.15 3.15 0 00-3.062 2.5h6.124zM13.875 10.25a.625.625 0 010-1.25h3.75a.625.625 0 010 1.25h-3.75zM13.875 12.75a.625.625 0 010-1.25h5a.625.625 0 010 1.25h-5z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.625 20.25a.625.625 0 01-.625-.625.625.625 0 00-1.25 0c0 .345-.28.625-.625.625h-6.25a.625.625 0 01-.625-.625.625.625 0 00-1.25 0c0 .345-.28.625-.625.625h-2.5A1.877 1.877 0 012 18.375v-12.5C2 4.841 2.84 4 3.875 4h16.25C21.159 4 22 4.84 22 5.875v12.5c0 1.034-.84 1.875-1.875 1.875h-2.5zm2.5-1.25c.345 0 .625-.28.625-.625v-12.5a.625.625 0 00-.625-.625H3.875a.625.625 0 00-.625.625v12.5c0 .345.28.625.625.625h1.982a1.883 1.883 0 011.768-1.25c.8 0 1.507.512 1.768 1.25h5.214a1.883 1.883 0 011.768-1.25c.8 0 1.507.512 1.768 1.25h1.982z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1j = /*#__PURE__*/React__namespace.forwardRef(SvgUserId);

  function SvgUserSquare(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3.563 8.626A.563.563 0 013 8.063V4.687C3 3.757 3.757 3 4.688 3h3.375a.563.563 0 010 1.125H4.687a.563.563 0 00-.562.563v3.375c0 .31-.252.563-.563.563zM20.438 8.626a.563.563 0 01-.563-.563V4.687a.563.563 0 00-.563-.562h-3.375a.563.563 0 010-1.125h3.376C20.242 3 21 3.757 21 4.688v3.375c0 .31-.252.563-.563.563zM4.688 21A1.69 1.69 0 013 19.312v-3.375a.563.563 0 011.125 0v3.376c0 .31.252.562.563.562h3.375a.563.563 0 010 1.125H4.687zM15.938 21a.563.563 0 010-1.125h3.374c.311 0 .563-.252.563-.563v-3.375a.563.563 0 011.125 0v3.376A1.69 1.69 0 0119.312 21h-3.375zM12 13.125a3.66 3.66 0 01-3.656-3.656A3.66 3.66 0 0112 5.813a3.66 3.66 0 013.656 3.656A3.66 3.66 0 0112 13.125zm0-6.188A2.534 2.534 0 009.469 9.47 2.534 2.534 0 0012 12a2.534 2.534 0 002.531-2.531A2.534 2.534 0 0012 6.938zM16.752 17.625a.563.563 0 01-.531-.377 4.477 4.477 0 00-5.695-2.748 4.45 4.45 0 00-2.748 2.748.562.562 0 11-1.062-.37 5.568 5.568 0 013.44-3.44 5.569 5.569 0 011.84-.313 5.605 5.605 0 015.288 3.752.559.559 0 01-.346.716.553.553 0 01-.186.032z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1i = /*#__PURE__*/React__namespace.forwardRef(SvgUserSquare);

  function SvgWhatsapp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.883 17.58h.359a3.51 3.51 0 001.868-.45 3.534 3.534 0 001.357-1.368 1.773 1.773 0 00.125-1.742 1.276 1.276 0 00-.609-.46l-.116-.06s-1.442-.711-1.742-.837a.996.996 0 00-1.283.36c-.142.21-.292.427-.4.57a6.9 6.9 0 01-2.975-2.513l.191-.176c.147-.123.264-.278.342-.453a1.06 1.06 0 000-.996c-.05-.1-.25-.603-.45-1.072l-.292-.704a1.382 1.382 0 00-1.075-.838 1.808 1.808 0 00-1.666.486 4.326 4.326 0 00-.833 4.75 9.365 9.365 0 002.891 3.687 9.3 9.3 0 004.308 1.816zM8.45 8.24a.565.565 0 01.375-.117.531.531 0 01.267.059l.291.703c.175.427.359.838.45 1.072l-.333.327a.956.956 0 00-.208 1.265A8.147 8.147 0 0013 14.799a.98.98 0 001.275-.21c.15-.175.375-.486.508-.687.275.118 1.05.495 1.534.738l.133.067h.075a1 1 0 01-.142.418 2.332 2.332 0 01-2.408 1.19 8.038 8.038 0 01-3.63-1.552 8.093 8.093 0 01-2.462-3.097A3.055 3.055 0 018.45 8.24z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.642 20.805a.631.631 0 00.427.855.622.622 0 00.356-.018l3.325-1.139a9.962 9.962 0 0010.079.248 10.023 10.023 0 003.756-3.647A10.09 10.09 0 0022 12.051c0-2.665-1.053-5.222-2.929-7.107A9.974 9.974 0 0012 2a9.974 9.974 0 00-7.071 2.944A10.078 10.078 0 002 12.051a9.878 9.878 0 001.717 5.587l-1.075 3.167zm.6-8.754a8.828 8.828 0 011.437-4.905 8.76 8.76 0 013.91-3.273 8.708 8.708 0 015.06-.533 8.736 8.736 0 014.5 2.387 8.808 8.808 0 012.418 4.5 8.836 8.836 0 01-.482 5.091 8.786 8.786 0 01-3.218 3.961A8.718 8.718 0 0112 20.771a8.718 8.718 0 01-4.817-1.44.622.622 0 00-.533-.076l-2.425.77L5 17.74a.631.631 0 00-.092-.586 8.632 8.632 0 01-1.666-5.102z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1h = /*#__PURE__*/React__namespace.forwardRef(SvgWhatsapp);

  function SvgWifi(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M52.5 109.375a17.5 17.5 0 1035 0 17.5 17.5 0 10-35 0zM100.917 78.44a43.75 43.75 0 00-61.869 0M119.496 59.88a70 70 0 00-98.992 0M135.625 38.972a96.25 96.25 0 00-131.25 0",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$1g = /*#__PURE__*/React__namespace.forwardRef(SvgWifi);

  function SvgAvatar$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-5.284c1.72 0 3.486.693 5.297 2.158-1.8 1.205-3.565 1.808-5.297 1.808-1.732 0-3.505-.603-5.322-1.889 1.828-1.384 3.602-2.077 5.322-2.077zM12 5.4a4.725 4.725 0 110 9.45 4.725 4.725 0 010-9.45z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1f = /*#__PURE__*/React__namespace.forwardRef(SvgAvatar$1);

  function SvgBell$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.055 19.874l.042-.112c.12-.388.55-.61.96-.496.41.114.645.52.525.908-.336 1.083-1.387 1.826-2.58 1.826s-2.243-.743-2.58-1.826c-.12-.387.115-.794.525-.908a.789.789 0 01.925.403l.036.093c.142.46.588.774 1.094.774.464 0 .877-.265 1.053-.662zM12 2c.392 0 .716.275.767.632l.007.1v1.263c3.396.383 6.02 3.257 6.02 6.728 0 2.416.217 4.125.57 5.24.155.489.284.736.339.817l.023.03c.548.44.218 1.288-.502 1.288H4.775c-.635 0-1-.683-.622-1.166l.027-.039c.1-.15.269-.51.452-1.132.356-1.212.573-2.87.573-5.038 0-3.471 2.625-6.345 6.02-6.728V2.732c0-.404.347-.732.775-.732z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1e = /*#__PURE__*/React__namespace.forwardRef(SvgBell$1);

  function SvgHeartBeat$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.977 11.732l1.073 3.693.048.128c.165.37.506.614.896.637h.129c.382-.027.725-.267.887-.635l.984-2.376.477.739.064.086a.73.73 0 00.552.255l3.648-.001-2.058 2.322-3.697 3.987c-.256.277-.61.433-.98.433-.324 0-.636-.12-.88-.335l-.1-.097-3.71-4.001-2.043-2.304h2.838l.13-.008c.345-.045.65-.264.808-.59l.934-1.933zm7.48-8.66c1.716.288 3.194 1.411 3.973 3.02a5.769 5.769 0 01.01 4.98l-.124.244-.101.145-1.123 1.266h-4.61l-.697-1.083-.078-.105a1.034 1.034 0 00-.892-.373l-.126.02a1.06 1.06 0 00-.741.63l-.823 1.984-1.04-3.581-.042-.124a1.053 1.053 0 00-.875-.65l-.13-.003-.126.013a1.055 1.055 0 00-.78.6L7.837 12.73H3.91l-1.122-1.265-.101-.145a5.762 5.762 0 01-.116-5.225c.778-1.608 2.256-2.732 3.972-3.02a5.292 5.292 0 014.504 1.38l.188.185.765.788.766-.791a5.3 5.3 0 014.692-1.566z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1d = /*#__PURE__*/React__namespace.forwardRef(SvgHeartBeat$1);

  function SvgHome$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 3c.488.002.957.174 1.324.482l.133.122 8.33 8.273a.715.715 0 01-.006 1.023.748.748 0 01-.96.065l-.083-.07-1.385-1.376v8.757c0 .367-.277.67-.637.717l-.1.007H5.384a.733.733 0 01-.73-.626l-.008-.098v-8.76l-1.384 1.378a.747.747 0 01-1.043.007.714.714 0 01-.077-.942l.07-.082 2.643-2.629a.692.692 0 01.014-.014l5.668-5.638A2.072 2.072 0 0112 3zm0 10.942a2.396 2.396 0 00-2.396 2.232l-.005.157v3.22H14.4v-3.22a2.395 2.395 0 00-2.4-2.39z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1c = /*#__PURE__*/React__namespace.forwardRef(SvgHome$1);

  function SvgAvatar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10a9.983 9.983 0 01-3.863 7.896l.075-.065a.755.755 0 01-.088.075A9.953 9.953 0 0112 22a9.957 9.957 0 01-6.124-2.094l-.013-.01A9.983 9.983 0 012 12C2 6.477 6.477 2 12 2zm0 15.679a7.28 7.28 0 00-4.498 1.556A8.47 8.47 0 0012 20.518c1.651 0 3.192-.47 4.498-1.283A7.273 7.273 0 0012 17.679zM12 3.48a8.519 8.519 0 00-5.715 14.836 8.763 8.763 0 0111.43 0A8.519 8.519 0 0012 3.481zm0 1.605a5.062 5.062 0 110 10.124 5.062 5.062 0 010-10.124zm0 1.482a3.58 3.58 0 100 7.16 3.58 3.58 0 000-7.16z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1b = /*#__PURE__*/React__namespace.forwardRef(SvgAvatar);

  function SvgBell(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.057 19.266c.41.114.645.52.525.908-.336 1.083-1.387 1.826-2.58 1.826s-2.243-.743-2.58-1.826c-.12-.387.115-.794.525-.908a.789.789 0 01.925.403l.036.093c.142.46.588.774 1.094.774.464 0 .877-.265 1.053-.662l.042-.112c.12-.388.55-.61.96-.496zM12 2c.392 0 .716.275.767.632l.007.1v1.263c3.396.383 6.02 3.257 6.02 6.728 0 2.416.217 4.125.57 5.24.137.435.255.678.318.784l.02.033.024.03c.52.419.249 1.204-.397 1.282l-.105.006H4.775c-.597 0-.956-.605-.681-1.079l.059-.087.027-.039c.1-.15.269-.51.452-1.132.356-1.212.573-2.87.573-5.038 0-3.471 2.625-6.345 6.02-6.728V2.732c0-.404.347-.732.775-.732zm0 3.415c-2.887 0-5.246 2.367-5.246 5.308 0 2.295-.235 4.084-.63 5.43l-.07.225-.068.208-.019.049h12l-.086-.253c-.4-1.265-.635-3.11-.635-5.66 0-2.94-2.36-5.307-5.246-5.307z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1a = /*#__PURE__*/React__namespace.forwardRef(SvgBell);

  function SvgHeartBeat(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.998 20.499c-.323 0-.63-.124-.863-.35l-.032-.031-3.75-3.94a.623.623 0 01-.173-.449.627.627 0 01.624-.617c.17 0 .335.07.452.194l3.737 3.926 3.75-3.925a.626.626 0 01.882-.02.632.632 0 01.02.89L12.9 20.11c-.23.243-.541.38-.874.388h-.029zM3.226 11.341a.623.623 0 01-.546-.323 5.42 5.42 0 01-.115-5.035A5.33 5.33 0 015.66 3.28a5.274 5.274 0 014.086.293c.516.26.983.6 1.39 1.01l.863.865.864-.87A5.298 5.298 0 0116.647 3c1.43 0 2.774.56 3.785 1.578.408.41.744.882 1.002 1.4a5.427 5.427 0 01-.111 5.035.625.625 0 01-.85.243.629.629 0 01-.242-.856 4.16 4.16 0 00.086-3.86 4.102 4.102 0 00-.768-1.072 4.06 4.06 0 00-2.9-1.208 4.06 4.06 0 00-2.902 1.208l-1.304 1.314a.618.618 0 01-.883 0l-1.306-1.31a4.087 4.087 0 00-1.067-.774 4.041 4.041 0 00-3.132-.224 4.086 4.086 0 00-2.372 2.072 4.156 4.156 0 00.089 3.86.634.634 0 01-.242.856.63.63 0 01-.304.079z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.055 15.758a.935.935 0 01-.893-.655l-1.18-3.953-1.087 2.184a.932.932 0 01-.839.521H2.625a.627.627 0 01-.625-.63c0-.346.28-.628.625-.628h5.238l1.35-2.72a.93.93 0 01.841-.525.942.942 0 01.902.685l1.15 3.86.967-2.276a.94.94 0 011.234-.495c.166.072.307.19.407.34l.746 1.126h5.915c.345 0 .625.282.625.63 0 .347-.28.629-.625.629h-6.25a.624.624 0 01-.52-.28l-.61-.922-1.08 2.541a.955.955 0 01-.572.521.942.942 0 01-.288.046z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$19 = /*#__PURE__*/React__namespace.forwardRef(SvgHeartBeat);

  function SvgHome(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.384 21a.736.736 0 01-.73-.633l-.008-.1v-8.744l-1.387 1.38a.741.741 0 01-1.043 0 .728.728 0 01-.072-.953l.072-.082 8.325-8.273a2.068 2.068 0 012.78-.114l.133.121 8.33 8.265a.728.728 0 010 1.035.741.741 0 01-.96.072l-.083-.071-1.388-1.378v8.743c0 .37-.277.677-.637.725l-.1.007H5.384zm6.611-16.536a.59.59 0 00-.343.11l-.07.058-5.461 5.425v9.478l2.495-.001v-3.207c0-1.856 1.515-3.36 3.384-3.36 1.806 0 3.282 1.405 3.379 3.175l.005.184-.001 3.208 2.496.001-.001-9.473-5.469-5.426a.588.588 0 00-.414-.172zM12 14.431c-1.004 0-1.827.77-1.903 1.747l-.006.148-.001 3.208h3.819v-3.207A1.902 1.902 0 0012 14.43z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$18 = /*#__PURE__*/React__namespace.forwardRef(SvgHome);

  function SvgDoctor$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.346 11.499a.187.187 0 00-.096.163v.811a.187.187 0 00.252.176c.16-.058.328-.089.498-.089h.354a.187.187 0 00.13-.322 5.606 5.606 0 00-.948-.736.188.188 0 00-.19-.003z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.425 10.991a4.216 4.216 0 10-3.779-.016.188.188 0 01.104.168v2.111a.189.189 0 00.107.17 1.125 1.125 0 11-.964 0 .188.188 0 00.107-.17v-1.593a.187.187 0 00-.285-.16A5.624 5.624 0 003 16.31a.375.375 0 00.375.375h6.938a.188.188 0 00.187-.188v-5.398a.11.11 0 00-.075-.107zM8.55 9.936a2.72 2.72 0 01-2.714-2.715c.001-.352.074-.7.212-1.024a.189.189 0 01.284-.075 5.717 5.717 0 003.375 1.103 5.68 5.68 0 001.35-.166.167.167 0 01.145.032.169.169 0 01.065.133A2.718 2.718 0 018.55 9.936zM19.875 13.503h-1.313a.375.375 0 01-.375-.375v-.375a1.313 1.313 0 00-1.312-1.312h-1.5a1.314 1.314 0 00-1.313 1.312v.375a.375.375 0 01-.374.375h-1.313a1.125 1.125 0 00-1.125 1.124v5.248A1.124 1.124 0 0012.375 21h7.5A1.125 1.125 0 0021 19.875v-5.248a1.124 1.124 0 00-1.125-1.124zm-4.688-.75a.188.188 0 01.188-.188h1.5a.188.188 0 01.188.188v.375a.375.375 0 01-.375.375h-1.125a.375.375 0 01-.376-.375v-.375zM18 17.813a.188.188 0 01-.188.188h-.562a.375.375 0 00-.375.375v.562a.188.188 0 01-.188.188h-1.125a.188.188 0 01-.187-.188v-.562A.375.375 0 0015 18h-.563a.188.188 0 01-.187-.187v-1.125a.188.188 0 01.188-.187H15a.375.375 0 00.375-.375v-.562a.188.188 0 01.188-.188h1.124a.188.188 0 01.188.188v.562a.375.375 0 00.375.375h.563a.188.188 0 01.187.187v1.125z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$17 = /*#__PURE__*/React__namespace.forwardRef(SvgDoctor$1);

  function SvgDrop$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.737 2.36a.897.897 0 00-.323-.265.942.942 0 00-.828 0 .897.897 0 00-.323.266C11.2 2.453 5 11.779 5 15.325c0 1.77.737 3.468 2.05 4.72C8.363 21.297 10.143 22 12 22c1.857 0 3.637-.703 4.95-1.955 1.313-1.252 2.05-2.95 2.05-4.72 0-3.545-6.2-12.872-6.263-12.964zM12 19.707a4.715 4.715 0 01-3.247-1.285 4.285 4.285 0 01-1.347-3.096c0-.166.07-.325.192-.442a.673.673 0 01.465-.183c.174 0 .34.066.464.183a.611.611 0 01.192.442c0 .83.347 1.625.962 2.212a3.369 3.369 0 002.319.917c.174 0 .341.066.464.183a.611.611 0 01.192.443c0 .166-.069.325-.192.442a.672.672 0 01-.464.184z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$16 = /*#__PURE__*/React__namespace.forwardRef(SvgDrop$1);

  function SvgHospital$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M43.75 52.5A26.25 26.25 0 1017.5 26.25 26.28 26.28 0 0043.75 52.5zM32.083 21.875h4.375a2.917 2.917 0 002.917-2.917v-4.375a4.375 4.375 0 018.75 0v4.375a2.917 2.917 0 002.917 2.917h4.375a4.375 4.375 0 010 8.75h-4.375a2.917 2.917 0 00-2.917 2.917v4.375a4.375 4.375 0 01-8.75 0v-4.375a2.917 2.917 0 00-2.917-2.917h-4.375a4.375 4.375 0 010-8.75z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M67.083 75.833h17.5a2.917 2.917 0 002.917-2.916V40.833a8.552 8.552 0 00-6.113-8.295 2.917 2.917 0 00-3.693 2.094 34.953 34.953 0 01-67.888 0 2.917 2.917 0 00-3.693-2.094A8.552 8.552 0 000 40.833v93.334A5.833 5.833 0 005.833 140h41.079a2.917 2.917 0 002.876-3.412 14.373 14.373 0 01-.205-2.421V93.333a17.5 17.5 0 0117.5-17.5zM35 121.042H17.5a4.375 4.375 0 010-8.75H35a4.375 4.375 0 010 8.75zm0-20.417H17.5a4.375 4.375 0 010-8.75H35a4.375 4.375 0 010 8.75zm2.917-20.417H17.5a4.375 4.375 0 010-8.75h20.417a4.375 4.375 0 010 8.75z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M131.25 84.583H67.083a8.75 8.75 0 00-8.75 8.75v40.834A5.833 5.833 0 0064.167 140h20.416a2.917 2.917 0 002.917-2.917v-5.833a11.667 11.667 0 0123.333 0v5.833A2.917 2.917 0 00113.75 140h20.417a5.833 5.833 0 005.833-5.833V93.333a8.75 8.75 0 00-8.75-8.75zm-40.833 21.875H75.833a4.375 4.375 0 010-8.75h14.584a4.375 4.375 0 010 8.75zm32.083 0h-14.583a4.375 4.375 0 010-8.75H122.5a4.375 4.375 0 010 8.75z"
    }));
  }

  var ForwardRef$15 = /*#__PURE__*/React__namespace.forwardRef(SvgHospital$1);

  function SvgLab$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.558 18.12l-3.878-6.152a.794.794 0 01-.122-.424v-7.46c0-.111.047-.217.13-.295a.46.46 0 01.314-.122h1.333a.92.92 0 00.629-.244.808.808 0 00.26-.59.808.808 0 00-.26-.589.92.92 0 00-.629-.244H6.67a.92.92 0 00-.628.244.808.808 0 00-.26.59c0 .22.093.432.26.589a.92.92 0 00.628.244h1.334a.46.46 0 01.314.122c.083.078.13.184.13.294v7.462a.794.794 0 01-.123.423l-3.843 6.1a2.37 2.37 0 00-.18 2.585c.224.405.563.745.979.982A2.8 2.8 0 006.66 22h10.68a2.801 2.801 0 001.366-.357c.413-.232.75-.565.978-.962a2.372 2.372 0 00-.127-2.56zM9.045 15.334a.467.467 0 01-.223-.056.43.43 0 01-.162-.154.397.397 0 01.003-.418l1.437-2.28a.805.805 0 00.125-.425V4.083c0-.11.047-.216.13-.294a.46.46 0 01.314-.122h2.667a.46.46 0 01.314.122c.083.078.13.184.13.294v2.292c0 .11-.047.216-.13.295a.46.46 0 01-.314.122h-1.174a.69.69 0 00-.47.183.606.606 0 00-.196.442c0 .165.07.324.195.442a.69.69 0 00.471.183h1.174a.46.46 0 01.314.122c.083.078.13.184.13.294v.834c0 .11-.047.216-.13.294a.46.46 0 01-.314.122h-1.174a.69.69 0 00-.47.183.606.606 0 00-.196.442c0 .166.07.325.195.442a.69.69 0 00.471.183h1.174a.46.46 0 01.314.122c.083.079.13.184.13.295V12c0 .15.043.296.124.424l1.438 2.281a.397.397 0 01.003.418.43.43 0 01-.163.154.468.468 0 01-.222.056H9.045zm.723 4.852c-.264 0-.522-.073-.74-.21a1.27 1.27 0 01-.492-.562c-.1-.228-.127-.48-.076-.722.052-.242.179-.465.365-.64.187-.175.424-.294.683-.342.258-.048.527-.023.77.071.244.095.452.255.598.46.147.206.225.448.225.695 0 .332-.14.65-.39.884a1.38 1.38 0 01-.943.366zm3.75-2.514a.931.931 0 01-.494-.14.848.848 0 01-.327-.375.786.786 0 01-.05-.481.82.82 0 01.242-.427.908.908 0 01.456-.228.944.944 0 01.513.048.88.88 0 01.399.306.797.797 0 01.082.782.833.833 0 01-.193.27.896.896 0 01-.288.181.94.94 0 01-.34.064zm2.222 2.568a.931.931 0 01-.494-.14.847.847 0 01-.327-.374.785.785 0 01-.05-.482.818.818 0 01.242-.426.909.909 0 01.456-.229.945.945 0 01.513.048c.163.063.301.17.399.307a.796.796 0 01-.112 1.054.895.895 0 01-.29.18.94.94 0 01-.341.062h.004z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$14 = /*#__PURE__*/React__namespace.forwardRef(SvgLab$1);

  function SvgMeet$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.125 18C3.402 18 2 16.654 2 15V9c0-1.654 1.402-3 3.125-3h7.5c1.723 0 3.125 1.346 3.125 3v6c0 1.654-1.402 3-3.125 3h-7.5z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.192 16.302a1.273 1.273 0 00.955.065c.316-.1.573-.315.722-.602.086-.166.131-.35.131-.535V8.77c0-.32-.13-.621-.366-.848a1.294 1.294 0 00-1.443-.225l-2.846 1.366a.601.601 0 00-.335.432L17 9.5v5l.01.004c.032.18.15.345.335.433l2.847 1.365z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$13 = /*#__PURE__*/React__namespace.forwardRef(SvgMeet$1);

  function SvgRdi$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.75 2H3.25A1.25 1.25 0 002 3.25v17.5A1.25 1.25 0 003.25 22h17.5A1.25 1.25 0 0022 20.75V3.25A1.25 1.25 0 0020.75 2zm-1.853 8.083a.833.833 0 01-1.172.123 8.714 8.714 0 00-4.428-1.672.417.417 0 00-.464.417v1.235a.417.417 0 00.38.416c.781.068 1.554.21 2.309.425.58.166 1.145.382 1.688.646a.833.833 0 01-.367 1.583.819.819 0 01-.365-.084 8.812 8.812 0 00-1.416-.541 10.507 10.507 0 00-1.763-.344.417.417 0 00-.462.417v1.031a.416.416 0 00.379.417c.781.067 1.555.21 2.309.424a.833.833 0 01-.232 1.634.86.86 0 01-.235-.043 10.58 10.58 0 00-1.762-.345.416.416 0 00-.463.417v2.22a.834.834 0 01-1.666 0v-2.22a.418.418 0 00-.463-.417 10.58 10.58 0 00-1.762.345.835.835 0 01-.464-1.602 12.313 12.313 0 012.31-.424.417.417 0 00.379-.417v-1.027a.417.417 0 00-.464-.417c-.596.064-1.185.179-1.761.343-.487.14-.961.321-1.417.542a.834.834 0 11-.732-1.5c.544-.264 1.109-.48 1.69-.646a12.288 12.288 0 012.308-.424.417.417 0 00.379-.417V8.946a.415.415 0 00-.464-.417 8.714 8.714 0 00-4.431 1.674.833.833 0 01-1.05-1.294 10.377 10.377 0 015.563-2.058.417.417 0 00.379-.417V5.125a.834.834 0 011.666 0v1.312a.417.417 0 00.38.416c2.014.13 3.948.846 5.562 2.059a.833.833 0 01.122 1.171z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$12 = /*#__PURE__*/React__namespace.forwardRef(SvgRdi$1);

  function SvgTelemedicine$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.815 18.209a2.796 2.796 0 01-.276-.397.376.376 0 00-.325-.188H4.875a.375.375 0 01-.375-.374V5.625a.375.375 0 01.375-.375h8.25a.375.375 0 01.375.375v1.32a.375.375 0 00.375.374c.224 0 .447.025.665.075a.375.375 0 00.46-.367V5.25A2.257 2.257 0 0012.75 3h-7.5A2.257 2.257 0 003 5.25v13.5A2.257 2.257 0 005.25 21h4.084a.374.374 0 00.288-.615l-1.807-2.176z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.062 12.375h1.125a.566.566 0 00.563-.563v-.75a.187.187 0 01.187-.187h.75a.188.188 0 00.188-.188v-.367c0-.396.08-.788.236-1.151a.375.375 0 00-.172-.48.54.54 0 00-.252-.064h-.75a.187.187 0 01-.187-.188v-.75a.566.566 0 00-.563-.563H8.062a.566.566 0 00-.562.563v.75a.187.187 0 01-.188.187h-.75A.566.566 0 006 9.187v1.125a.566.566 0 00.562.562h.75a.188.188 0 01.188.188v.75a.566.566 0 00.562.563zM17.25 14.25h-1.5v-4.125a1.875 1.875 0 00-3.75 0v5.296l-.434-.525a1.875 1.875 0 00-2.884 2.4l2.854 3.434a.751.751 0 001.154-.96l-2.854-3.434a.375.375 0 01.577-.479l1.76 2.117a.75.75 0 001.327-.48v-7.37a.375.375 0 11.75 0V15a.75.75 0 00.75.75h2.25A2.25 2.25 0 0119.5 18v2.25a.75.75 0 001.5 0V18a3.754 3.754 0 00-3.75-3.75z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$11 = /*#__PURE__*/React__namespace.forwardRef(SvgTelemedicine$1);

  function SvgDoctor(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.188 21a1.314 1.314 0 01-1.313-1.313v-5.25c0-.723.589-1.312 1.313-1.312h1.5v-.938c0-.723.588-1.312 1.312-1.312h1.875c.724 0 1.313.589 1.313 1.313v.937h1.5c.723 0 1.312.589 1.312 1.313v5.25C21 20.41 20.411 21 19.687 21h-7.5zm0-6.75a.188.188 0 00-.188.188v5.25c0 .103.084.187.188.187h7.5a.188.188 0 00.187-.188v-5.25a.188.188 0 00-.188-.187h-7.5zm4.874-1.125v-.938a.188.188 0 00-.187-.187H15a.188.188 0 00-.188.188v.937h2.25z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15.938 18.75a.563.563 0 01-.563-.563v-.562h-.563a.563.563 0 010-1.125h.563v-.563a.563.563 0 011.125 0v.563h.563a.563.563 0 010 1.125H16.5v.563c0 .31-.252.562-.563.562zM8.625 16.5a.563.563 0 01-.563-.563v-4.463a4.494 4.494 0 00-2.616 1.281 4.47 4.47 0 00-1.321 3.182.563.563 0 01-1.125 0 5.638 5.638 0 015.656-5.623 5.577 5.577 0 012.177.45.563.563 0 01-.441 1.035 4.474 4.474 0 00-1.204-.325v4.463c0 .311-.253.563-.563.563z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.625 10.313a3.66 3.66 0 01-3.656-3.657c0-.629.165-1.252.479-1.803.013-.026.026-.045.034-.058A3.675 3.675 0 018.625 3a3.676 3.676 0 013.61 3.104.51.51 0 01.017.114c.02.163.03.303.03.438a3.66 3.66 0 01-3.657 3.657zM6.173 6.027a2.534 2.534 0 002.452 3.16c1.27 0 2.326-.942 2.504-2.163-.479.128-.972.194-1.469.194h-.005a5.691 5.691 0 01-3.482-1.191zm3.504.067c.454-.001.913-.072 1.357-.213a2.548 2.548 0 00-2.409-1.757 2.53 2.53 0 00-1.92.888 4.629 4.629 0 002.944 1.08h.009c.005 0 .013 0 .02.002z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$10 = /*#__PURE__*/React__namespace.forwardRef(SvgDoctor);

  function SvgDrop(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.667 22C7.991 22 5 19.123 5 15.588c0-4.287 3.88-10.52 5.549-13A1.336 1.336 0 0111.668 2c.253 0 .5.07.713.2.164.1.3.232.405.39 1.667 2.478 5.547 8.71 5.547 12.998.001 3.536-2.99 6.412-6.666 6.412zm0-18.713c-1.258 1.87-5.334 8.25-5.334 12.302 0 2.828 2.393 5.13 5.334 5.13 2.94 0 5.334-2.302 5.334-5.13 0-4.056-4.08-10.439-5.334-12.302z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.667 19.438c-2.205 0-4-1.726-4-3.847 0-.354.299-.642.667-.642.368 0 .666.287.666.64 0 1.416 1.197 2.567 2.667 2.567.368 0 .667.288.667.642 0 .353-.299.64-.667.64z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$$ = /*#__PURE__*/React__namespace.forwardRef(SvgDrop);

  function SvgHospital(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M52.5 135.625v-43.75a8.75 8.75 0 018.75-8.75h61.25a8.75 8.75 0 018.75 8.75v43.75H35M8.75 56.875v78.75M78.75 83.125V61.361M17.5 30.625a26.25 26.25 0 1052.5 0 26.25 26.25 0 10-52.5 0zM43.75 21.875v17.5M35 30.625h17.5M26.25 83.125H35M26.25 109.375H35M74.375 118.236h8.75M100.625 118.236h8.75M74.375 100.736h8.75M100.625 100.736h8.75",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$_ = /*#__PURE__*/React__namespace.forwardRef(SvgHospital);

  function SvgLab(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.556 22a2.23 2.23 0 01-1.392-.505c-1.184-.94-1.52-2.878-.752-4.323L8.928 8.69V3.25h-.512c-.282 0-.512-.28-.512-.625S8.134 2 8.416 2h7.167c.282 0 .512.28.512.625s-.23.625-.512.625h-.512v5.44l4.515 8.482c.27.509.414 1.097.414 1.703 0 .834-.266 1.62-.75 2.21-.483.59-1.126.915-1.81.915H6.556zM5.27 17.853c-.461.867-.26 2.031.45 2.595.25.197.538.302.835.303H17.44c.41 0 .796-.195 1.086-.55.29-.354.45-.824.45-1.325a2.18 2.18 0 00-.248-1.022l-2.45-4.603H7.72l-2.45 4.602zM15.612 12L14.13 9.216a.729.729 0 01-.083-.341V8.25h-1.536c-.282 0-.512-.28-.512-.625S12.23 7 12.511 7h1.536V5.75h-1.536c-.282 0-.512-.28-.512-.625s.23-.625.512-.625h1.536V3.25H9.952v5.625c0 .122-.029.24-.083.34L8.387 12h7.225z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.603 17.625a.563.563 0 01-.563-.563V16.5h-.562a.563.563 0 010-1.125h.562v-.563a.563.563 0 011.125 0v.563h.563a.563.563 0 010 1.125h-.563v.563c0 .31-.252.562-.562.562zM7.852 18.469a.56.56 0 01-.1-.01.845.845 0 01-.735-.736.539.539 0 010-.196.845.845 0 01.93-.738.844.844 0 01.739.738.539.539 0 010 .196.843.843 0 01-.735.737.528.528 0 01-.1.009zM10.102 16.219a.56.56 0 01-.1-.01.845.845 0 01-.735-.736.539.539 0 010-.196.845.845 0 01.932-.737.84.84 0 01.746.835c0 .034-.004.07-.01.104a.846.846 0 01-.833.74z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$Z = /*#__PURE__*/React__namespace.forwardRef(SvgLab);

  function SvgMeet(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.125 18C3.402 18 2 16.654 2 15V9c0-1.654 1.402-3 3.125-3h7.5c1.723 0 3.125 1.346 3.125 3v6c0 1.654-1.402 3-3.125 3h-7.5zm0-10.8C4.091 7.2 3.25 8.007 3.25 9v6c0 .993.84 1.8 1.875 1.8h7.5c1.034 0 1.875-.807 1.875-1.8V9c0-.993-.84-1.8-1.875-1.8h-7.5zM20.75 16.43c-.195 0-.383-.043-.558-.128l-2.847-1.365a.59.59 0 01-.28-.805.625.625 0 01.56-.332c.096 0 .192.022.278.063l2.847 1.366V8.77l-2.846 1.367a.649.649 0 01-.279.063.626.626 0 01-.56-.331.59.59 0 01.28-.805l2.846-1.366a1.294 1.294 0 011.443.225c.237.227.366.527.366.848v6.459c0 .184-.045.37-.13.535-.15.287-.408.502-.723.602-.129.041-.263.063-.398.063z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$Y = /*#__PURE__*/React__namespace.forwardRef(SvgMeet);

  function SvgRdi(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M.75.75h22.5v22.5H.75zM12 5.25v13.5"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.25 9c0-1.243 3.022-2.25 6.75-2.25S18.75 7.757 18.75 9M4.5 13.5c0-1.243 3.358-2.25 7.5-2.25s7.5 1.007 7.5 2.25M6.75 17.25c0-.828 2.35-1.5 5.25-1.5s5.25.672 5.25 1.5"
    })));
  }

  var ForwardRef$X = /*#__PURE__*/React__namespace.forwardRef(SvgRdi);

  function SvgTelemedicine(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.438 21a.563.563 0 01-.563-.563v-2.594c0-.828-.593-1.528-1.41-1.664l-1.495-.249a.562.562 0 01-.47-.555v-2.25a.563.563 0 00-1.125 0v3.938a.567.567 0 01-.563.562.562.562 0 01-.25-.06l-.882-.44a.666.666 0 00-.944.434.668.668 0 00.23.681l2.198 1.758a.563.563 0 01-.703.879l-2.196-1.758a1.794 1.794 0 01-.619-1.832 1.787 1.787 0 012.539-1.166l.065.032v-3.028c0-.93.757-1.688 1.688-1.688.93 0 1.687.757 1.687 1.688v1.774l1.024.17A2.802 2.802 0 0121 17.844v2.595c0 .31-.252.562-.563.562z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.25 21C4.01 21 3 19.99 3 18.75V5.25C3 4.01 4.01 3 5.25 3H12c1.24 0 2.25 1.01 2.25 2.25v5.063a.563.563 0 01-1.125 0V5.25c0-.62-.505-1.125-1.125-1.125H5.25c-.62 0-1.125.505-1.125 1.125V16.5h6.188a.563.563 0 010 1.125H4.125v1.125c0 .62.505 1.125 1.125 1.125h6.188a.563.563 0 010 1.125H5.25z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.063 13.688c-.62 0-1.126-.505-1.126-1.126V12h-.562c-.62 0-1.125-.505-1.125-1.125V9.75c0-.62.505-1.125 1.125-1.125h.563v-.563c0-.62.504-1.124 1.125-1.124h1.124c.62 0 1.126.504 1.126 1.125v.562h.562c.62 0 1.125.505 1.125 1.125v1.125c0 .62-.505 1.125-1.125 1.125h-.563v.563c0 .62-.504 1.124-1.124 1.124H8.062zm-1.688-2.813H7.5c.31 0 .563.252.563.563v1.124h1.124v-1.124c0-.311.253-.563.563-.563h1.125V9.75H9.75a.563.563 0 01-.563-.563V8.063H8.063v1.124c0 .311-.253.563-.563.563H6.375v1.125z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$W = /*#__PURE__*/React__namespace.forwardRef(SvgTelemedicine);

  function SvgAdd$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2 12a1.25 1.25 0 001.25 1.25h7.292a.208.208 0 01.208.208v7.292a1.25 1.25 0 002.5 0v-7.292a.208.208 0 01.208-.208h7.292a1.25 1.25 0 000-2.5h-7.292a.208.208 0 01-.208-.208V3.25a1.25 1.25 0 00-2.5 0v7.292a.208.208 0 01-.208.208H3.25A1.25 1.25 0 002 12z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$V = /*#__PURE__*/React__namespace.forwardRef(SvgAdd$1);

  function SvgArrowLeft$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.946 10.916H7.077a.19.19 0 01-.124-.33l6.496-5.715a1.083 1.083 0 00-1.43-1.626l-8.408 7.4a1.805 1.805 0 000 2.707l8.407 7.398a1.083 1.083 0 001.43-1.625l-6.496-5.716a.189.189 0 01.124-.33h12.87a1.083 1.083 0 000-2.165v.002z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$U = /*#__PURE__*/React__namespace.forwardRef(SvgArrowLeft$1);

  function SvgCameraOff$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.638 7.36a.21.21 0 00-.233-.043 1.25 1.25 0 00-.738 1.141v7.5a1.25 1.25 0 001.25 1.25h9.066a.208.208 0 00.147-.355L4.638 7.36zM20.114 8.21l-2.5 1.425A1.205 1.205 0 0017 10.677v3.063a1.208 1.208 0 00.614 1.042l2.5 1.425A1.25 1.25 0 0022 15.168V9.25a1.25 1.25 0 00-1.886-1.04z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.228 15.05a.206.206 0 01-.061-.148V8.458a1.25 1.25 0 00-1.25-1.25H8.473a.208.208 0 01-.147-.06L3.423 2.244a.833.833 0 00-1.179 1.179l18.334 18.333a.833.833 0 001.178-1.178l-5.528-5.529z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$T = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOff$1);

  function SvgCameraOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.208 6.582a2 2 0 00-2 2v6.834a2 2 0 002 2h8.5a2 2 0 002-2V8.582a2 2 0 00-2-2h-8.5zM21.394 7a.417.417 0 01.398.417v9.166a.417.417 0 01-.604.373l-5-2.5a.416.416 0 01-.23-.373V9.917a.416.416 0 01.23-.374l5-2.5A.416.416 0 0121.394 7z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$S = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOn$1);

  function SvgCheckMark(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M41.86 131.25a23.982 23.982 0 01-18.494-8.666L2.254 95.746a10.5 10.5 0 1116.492-12.992l21 26.6a2.24 2.24 0 002.212.882 3.038 3.038 0 002.38-1.148l76.958-96.39a10.5 10.5 0 1116.408 13.104L60.606 122.29A24.038 24.038 0 0142 131.25z"
    }));
  }

  var ForwardRef$R = /*#__PURE__*/React__namespace.forwardRef(SvgCheckMark);

  function SvgChevronDown$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.021 17.636a1.724 1.724 0 001.297-.585l7.358-8.363a1.385 1.385 0 00-2.08-1.83l-6.434 7.314a.187.187 0 01-.282 0L5.446 6.858a1.385 1.385 0 10-2.08 1.83l7.356 8.36a1.734 1.734 0 001.3.588z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$Q = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDown$1);

  function SvgChevronLeft$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5 11.979a1.725 1.725 0 01.585-1.297l8.364-7.358a1.385 1.385 0 011.829 2.08l-7.314 6.434a.188.188 0 000 .282l7.314 6.434a1.386 1.386 0 11-1.83 2.08l-8.36-7.356a1.733 1.733 0 01-.588-1.3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$P = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeft$1);

  function SvgChevronRight$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.273 11.979a1.724 1.724 0 00-.585-1.297L9.324 3.324a1.385 1.385 0 00-1.83 2.08l7.315 6.434a.188.188 0 010 .282l-7.314 6.434a1.385 1.385 0 101.829 2.08l8.36-7.356a1.733 1.733 0 00.589-1.3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$O = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRight$1);

  function SvgChevronUp$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.979 6.364a1.725 1.725 0 00-1.297.585l-7.358 8.363a1.385 1.385 0 002.08 1.83l6.434-7.314a.188.188 0 01.282 0l6.434 7.314a1.386 1.386 0 102.08-1.83l-7.356-8.36a1.733 1.733 0 00-1.3-.588z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$N = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUp$1);

  function SvgClose$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.724 12.132a.19.19 0 01-.04-.204.187.187 0 01.04-.061l6.947-6.946a1.126 1.126 0 00-1.593-1.59l-6.946 6.942a.187.187 0 01-.265 0L4.92 3.33a1.125 1.125 0 00-1.592 1.59l6.945 6.947a.187.187 0 010 .265L3.33 19.08a1.126 1.126 0 001.592 1.59l6.946-6.946a.187.187 0 01.265 0l6.946 6.947a1.126 1.126 0 001.591-1.591l-6.945-6.947z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$M = /*#__PURE__*/React__namespace.forwardRef(SvgClose$1);

  function SvgExclam(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 8 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M1.609.851a2.905 2.905 0 00-.852 2.055v13.076a2.905 2.905 0 005.813 0V2.906A2.905 2.905 0 001.608.85zM3.664 29.124h.058a3.634 3.634 0 10-.058-7.264h-.061a3.633 3.633 0 10.06 7.264z"
    }));
  }

  var ForwardRef$L = /*#__PURE__*/React__namespace.forwardRef(SvgExclam);

  function SvgLoading$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21 12c0-2.21-.796-4.233-2.118-5.8A9 9 0 1012 21",
      stroke: "url(#loading_svg__paint0_angular)",
      strokeWidth: 3,
      strokeLinecap: "round"
    }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("radialGradient", {
      id: "loading_svg__paint0_angular",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "rotate(68.2 -2.862 14.862) scale(9.08754)"
    }, /*#__PURE__*/React__namespace.createElement("stop", {
      offset: 0.042,
      stopOpacity: 0
    }), /*#__PURE__*/React__namespace.createElement("stop", {
      offset: 0.824
    }))));
  }

  var ForwardRef$K = /*#__PURE__*/React__namespace.forwardRef(SvgLoading$1);

  function SvgMicrophoneOff$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.463 17.29l3.293 3.294-.006-.004a.834.834 0 01-1.167 1.188l-.005-.006L2.244 3.43a.833.833 0 010-1.179.844.844 0 011.179 0l3.433 3.43a.21.21 0 00.347-.089A5 5 0 0117 7.001v5.416a4.97 4.97 0 01-.673 2.513.21.21 0 00.032.25l.607.606a.206.206 0 00.32-.036 6.216 6.216 0 00.964-3.333v-2.083a.834.834 0 011.667 0v2.083a7.877 7.877 0 01-1.476 4.605.207.207 0 00.022.268zM12 18.667a6.257 6.257 0 01-6.25-6.25v-2.084a.833.833 0 00-1.667 0v2.084a7.928 7.928 0 006.902 7.851.208.208 0 01.182.207v.692a.833.833 0 001.666 0v-.692a.207.207 0 01.182-.207 7.862 7.862 0 003.216-1.166.21.21 0 00.085-.245.21.21 0 00-.05-.079l-.909-.909a.208.208 0 00-.25-.033 6.207 6.207 0 01-3.107.83zM7.356 9.872A.208.208 0 007 10.02v2.398a5 5 0 007.06 4.556.208.208 0 00.06-.334L7.357 9.873z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$J = /*#__PURE__*/React__namespace.forwardRef(SvgMicrophoneOff$1);

  function SvgMicrophoneOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 16c1.26-.001 2.467-.446 3.357-1.237.89-.79 1.392-2.145 1.393-3.263v-6c0-1.119-.5-2.473-1.391-3.264C14.468 1.444 13.259 1 12 1c-1.26 0-2.468.444-3.359 1.236-.89.79-1.391 2.145-1.391 3.264v6c.001 1.118.502 2.472 1.393 3.263.89.79 2.098 1.236 3.357 1.237z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19 8a1 1 0 00-1 1v2.5a6 6 0 11-12 0V9a1 1 0 00-2 0v2.5a8.013 8.013 0 006.788 7.908.25.25 0 01.212.247v.845a1 1 0 002 0v-.845a.25.25 0 01.212-.247A8.012 8.012 0 0020 11.5V9a1 1 0 00-1-1z"
    }));
  }

  var ForwardRef$I = /*#__PURE__*/React__namespace.forwardRef(SvgMicrophoneOn$1);

  function SvgNav1$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 6a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 22a2 2 0 100-4 2 2 0 000 4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$H = /*#__PURE__*/React__namespace.forwardRef(SvgNav1$1);

  function SvgPhone$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.894 16.174l-2.043-2.044a2.342 2.342 0 00-3.316 0l-.417.417A45.312 45.312 0 019.45 8.87l.417-.417a2.347 2.347 0 000-3.315L7.819 3.097a2.402 2.402 0 00-3.32 0L3.384 4.22a3.317 3.317 0 00-.416 4.162A45.143 45.143 0 0015.61 21.027a3.346 3.346 0 004.166-.416l1.121-1.122a2.343 2.343 0 000-3.314h-.004z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$G = /*#__PURE__*/React__namespace.forwardRef(SvgPhone$1);

  function SvgRefresh$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.107 7.133a6.919 6.919 0 017.018-1.703 1.05 1.05 0 10.639-2A9.035 9.035 0 003.635 15.425a.208.208 0 01-.079.252l-1.176.775a.841.841 0 00.292 1.526l3.704.763a.826.826 0 00.699-.172.84.84 0 00.292-.483l.768-3.702a.84.84 0 00-1.285-.872l-1.126.74a.21.21 0 01-.316-.111 6.95 6.95 0 011.699-7.008zM21.987 6.852a.84.84 0 00-.641-.678l-3.688-.84a.84.84 0 00-1.008.631l-.84 3.687a.84.84 0 001.266.899l1.212-.762a.207.207 0 01.312.111 6.933 6.933 0 01-8.643 8.76 1.052 1.052 0 00-1.382 1.1 1.05 1.05 0 00.762.907A9.034 9.034 0 0020.392 8.674a.209.209 0 01.084-.252l1.131-.711a.84.84 0 00.38-.86z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$F = /*#__PURE__*/React__namespace.forwardRef(SvgRefresh$1);

  function SvgRemove$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3.25 13.25h17.5a1.25 1.25 0 000-2.5H3.25a1.25 1.25 0 000 2.5z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$E = /*#__PURE__*/React__namespace.forwardRef(SvgRemove$1);

  function SvgRoundCheckEmpty$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.444 3.685A10 10 0 0112 2a10.012 10.012 0 0110 10A10 10 0 116.444 3.685z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$D = /*#__PURE__*/React__namespace.forwardRef(SvgRoundCheckEmpty$1);

  function SvgRoundCheckOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.012 10.012 0 0012 2zm5.773 6.833l-5.705 7.741a.842.842 0 01-1.191.157l-4.074-3.257a.834.834 0 011.042-1.302l3.397 2.718 5.189-7.043a.834.834 0 111.341.986z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$C = /*#__PURE__*/React__namespace.forwardRef(SvgRoundCheckOn$1);

  function SvgSearch$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.725 19.375l-4.988-4.988a7.093 7.093 0 10-1.35 1.35l4.988 4.988a.967.967 0 001.35 0 .956.956 0 000-1.35zM4.962 10.116a5.157 5.157 0 115.156 5.157 5.163 5.163 0 01-5.156-5.157z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$B = /*#__PURE__*/React__namespace.forwardRef(SvgSearch$1);

  function SvgSquareCheckEmpty$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.159 3H19.84A1.16 1.16 0 0121 4.159V19.84A1.16 1.16 0 0119.841 21H4.16A1.16 1.16 0 013 19.84V4.16A1.16 1.16 0 014.159 3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$A = /*#__PURE__*/React__namespace.forwardRef(SvgSquareCheckEmpty$1);

  function SvgSquareCheckOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.841 3H4.16A1.16 1.16 0 003 4.159V19.84A1.16 1.16 0 004.159 21H19.84A1.16 1.16 0 0021 19.84V4.16A1.16 1.16 0 0019.841 3zm-2.737 5.883l-5.25 7.125a.76.76 0 01-1.073.14l-3.75-3a.752.752 0 01.102-1.25.75.75 0 01.836.08l3.14 2.512L15.9 7.992a.75.75 0 011.208.89l-.004.001z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$z = /*#__PURE__*/React__namespace.forwardRef(SvgSquareCheckOn$1);

  function SvgTrashBin$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.377 8.25H5.956a.417.417 0 00-.417.454l1.073 11.78A1.667 1.667 0 008.272 22h7.789a1.667 1.667 0 001.66-1.516l1.07-11.78a.418.418 0 00-.414-.454zM10.71 19.083a.625.625 0 11-1.25 0v-7.5a.625.625 0 011.25 0v7.5zm4.167 0a.625.625 0 01-1.25 0v-7.5a.625.625 0 111.25 0v7.5zM20.5 5.333h-3.958a.208.208 0 01-.209-.208V4.083A2.083 2.083 0 0014.25 2h-4.167A2.083 2.083 0 008 4.083v1.042a.208.208 0 01-.208.208H3.833a.833.833 0 000 1.667H20.5a.833.833 0 000-1.667zM9.667 5.125V4.083a.417.417 0 01.416-.416h4.167a.417.417 0 01.417.416v1.042a.208.208 0 01-.209.208H9.875a.208.208 0 01-.208-.208z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$y = /*#__PURE__*/React__namespace.forwardRef(SvgTrashBin$1);

  function SvgViewOff$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21.526 10.762a17.744 17.744 0 00-3.658-3l3.402-3.33a.834.834 0 00.26-.591.818.818 0 00-.25-.597.852.852 0 00-.608-.244.866.866 0 00-.605.254l-.015.015a.612.612 0 01-.147.243L3.317 19.762c-.007.006-.015.007-.022.014a.817.817 0 00-.027.56.835.835 0 00.342.45.864.864 0 001.072-.103l3.527-3.455a9.745 9.745 0 003.667.782h.255c3.62 0 7.221-2.486 9.4-4.833.303-.333.47-.763.469-1.209a1.789 1.789 0 00-.474-1.206zm-5.86 2.267a3.804 3.804 0 01-.957 1.57c-.445.44-.992.767-1.594.954a3.728 3.728 0 01-2.637-.159.214.214 0 01-.118-.155.207.207 0 01.06-.184l4.73-4.632a.216.216 0 01.281-.021.21.21 0 01.065.077c.375.8.436 1.709.17 2.55zM8.268 13.137a.202.202 0 00.052-.2 3.529 3.529 0 01-.15-.966c0-.995.403-1.949 1.121-2.652a3.869 3.869 0 012.707-1.098c.334.003.666.052.987.144a.212.212 0 00.204-.052l1.651-1.618a.211.211 0 00.058-.199.21.21 0 00-.143-.152 9.027 9.027 0 00-2.757-.415c-3.658-.048-7.316 2.458-9.516 4.833-.31.33-.48.76-.482 1.207-.001.447.169.878.476 1.21A17.93 17.93 0 005.4 15.702a.221.221 0 00.277-.024l2.59-2.542z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$x = /*#__PURE__*/React__namespace.forwardRef(SvgViewOff$1);

  function SvgViewOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21.53 10.94C19.323 8.512 15.666 5.95 12 6c-3.669-.052-7.326 2.514-9.53 4.94a1.843 1.843 0 000 2.457c2.178 2.4 5.784 4.941 9.395 4.941h.257c3.624 0 7.228-2.541 9.41-4.942a1.842 1.842 0 00-.003-2.457zM8.164 12.17a3.835 3.835 0 117.67 0 3.835 3.835 0 01-7.67 0z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.332 12.17a1.667 1.667 0 103.335 0 1.667 1.667 0 00-3.335 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$w = /*#__PURE__*/React__namespace.forwardRef(SvgViewOn$1);

  function SvgWarning$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M22 11.828a10.039 10.039 0 00-2.965-7.011 9.707 9.707 0 00-7.05-2.815 10.172 10.172 0 00-7.092 3.045 9.837 9.837 0 00-2.892 7.13 9.817 9.817 0 009.835 9.827h.18A10.093 10.093 0 0022 11.828zM10.79 7.156a1.211 1.211 0 012.421 0v5.45a1.211 1.211 0 01-2.421 0v-5.45zm1.237 10.927h-.026a1.514 1.514 0 01-.026-3.027h.026a1.514 1.514 0 11.024 3.027h.002z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$v = /*#__PURE__*/React__namespace.forwardRef(SvgWarning$1);

  function SvgAdd(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.425 2.426a.426.426 0 10-.85 0v9.149h-9.15a.426.426 0 100 .85h9.15v9.15a.425.425 0 10.85 0v-9.15h9.15a.425.425 0 100-.85h-9.15v-9.15z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$u = /*#__PURE__*/React__namespace.forwardRef(SvgAdd);

  function SvgApp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 .25A1.75 1.75 0 00.25 2v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 007.75 6V2A1.75 1.75 0 006 .25H2zM1.75 2A.25.25 0 012 1.75h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25H2A.25.25 0 011.75 6V2zM12 .25A1.75 1.75 0 0010.25 2v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0017.75 6V2A1.75 1.75 0 0016 .25h-4zM11.75 2a.25.25 0 01.25-.25h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25h-4a.25.25 0 01-.25-.25V2zM.25 12c0-.966.784-1.75 1.75-1.75h4c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 016 17.75H2A1.75 1.75 0 01.25 16v-4zM2 11.75a.25.25 0 00-.25.25v4c0 .138.112.25.25.25h4a.25.25 0 00.25-.25v-4a.25.25 0 00-.25-.25H2zM12 10.25A1.75 1.75 0 0010.25 12v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0017.75 16v-4A1.75 1.75 0 0016 10.25h-4zM11.75 12a.25.25 0 01.25-.25h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25h-4a.25.25 0 01-.25-.25v-4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$t = /*#__PURE__*/React__namespace.forwardRef(SvgApp);

  function SvgArrowLeft(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.438 20.875a.557.557 0 01-.398-.165l-7.875-7.875a.555.555 0 01-.122-.184c-.002-.006-.006-.012-.008-.02a.563.563 0 01.001-.39l.006-.015a.556.556 0 01.125-.187l7.873-7.874a.558.558 0 01.795 0 .557.557 0 01.165.397c0 .15-.059.292-.165.398L4.92 11.875h15.518a.563.563 0 010 1.125H4.92l6.915 6.915a.564.564 0 01-.399.96z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$s = /*#__PURE__*/React__namespace.forwardRef(SvgArrowLeft);

  function SvgCameraOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.375 4.375l131.25 131.25M91.875 65.625v-17.5a8.75 8.75 0 00-8.75-8.75H61.25M78.75 109.375H13.125a8.75 8.75 0 01-8.75-8.75v-52.5a8.75 8.75 0 018.75-8.75M114.21 94.296l15.086 7.536a4.375 4.375 0 006.329-3.914V50.832a4.375 4.375 0 00-6.33-3.915l-15.084 7.537a8.75 8.75 0 00-4.836 7.828v24.185a8.75 8.75 0 004.836 7.829z",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$r = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOff);

  function SvgCameraOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 5.5A2.5 2.5 0 001.5 8v8A2.5 2.5 0 004 18.5h9a2.5 2.5 0 002.5-2.5V8A2.5 2.5 0 0013 5.5H4zM2.5 8A1.5 1.5 0 014 6.5h9A1.5 1.5 0 0114.5 8v8a1.5 1.5 0 01-1.5 1.5H4A1.5 1.5 0 012.5 16V8zm18.884-.499a1.201 1.201 0 00-.561.113l.213.453-.214-.453-3.035 1.427a.5.5 0 10.426.905l3.035-1.427a.202.202 0 01.185.007.146.146 0 01.053.05c.01.017.014.035.014.05v6.747a.099.099 0 01-.014.05.146.146 0 01-.053.051.202.202 0 01-.185.007l-.212.453.212-.453-3.035-1.426a.5.5 0 00-.426.905l3.036 1.427a1.203 1.203 0 001.112-.049c.168-.097.31-.236.41-.405.101-.169.155-.362.155-.56V8.627H22h.5c0-.198-.054-.391-.154-.56-.1-.17-.243-.308-.41-.406a1.197 1.197 0 00-.552-.16z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$q = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOn);

  function SvgCameraSwitch(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M90.72 12.36A61.25 61.25 0 0170 131.25M102.252 32.008L90.72 12.36l23.158-4.072M49.28 127.64A61.25 61.25 0 0170 8.75",
      strokeWidth: 5.83333
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M37.747 107.993l11.533 19.646-23.158 4.072M107.917 90.417a5.833 5.833 0 01-5.834 5.833H43.75a5.833 5.833 0 01-5.833-5.833v-35a5.833 5.833 0 015.833-5.834h14.583l1.301-2.607a5.833 5.833 0 015.215-3.226h16.123a5.833 5.833 0 015.216 3.226l1.312 2.607h14.583a5.833 5.833 0 015.834 5.834z",
      strokeWidth: 5.83333
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M61.25 72.917a11.667 11.667 0 1023.333 0 11.667 11.667 0 10-23.333 0z",
      strokeWidth: 5.83333
    })));
  }

  var ForwardRef$p = /*#__PURE__*/React__namespace.forwardRef(SvgCameraSwitch);

  function SvgCheckboxEmpty(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.5 3h-15A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0019.5 3zm0 16.313a.188.188 0 01-.188.187H4.688a.187.187 0 01-.187-.188V4.688a.187.187 0 01.188-.187h14.625a.188.188 0 01.187.188v14.625z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$o = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxEmpty);

  function SvgCheckboxSelected(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.841 3H4.16A1.16 1.16 0 003 4.159V19.84A1.16 1.16 0 004.159 21H19.84A1.16 1.16 0 0021 19.84V4.16A1.16 1.16 0 0019.841 3zm-2.737 5.883l-5.25 7.125a.76.76 0 01-1.073.14l-3.75-3a.752.752 0 01.102-1.25.75.75 0 01.836.08l3.14 2.512L15.9 7.992a.75.75 0 011.208.89l-.004.001z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$n = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxSelected);

  function SvgChevronDown(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3 7.898c0 .15.058.292.165.397l8.04 8.04c.212.213.494.33.794.33.3 0 .583-.117.795-.329l8.041-8.04A.557.557 0 0021 7.897a.557.557 0 00-.165-.398.557.557 0 00-.795 0L12 15.54 3.96 7.5a.558.558 0 00-.795 0A.561.561 0 003 7.898z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$m = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDown);

  function SvgChevronLeft(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.767 21a.557.557 0 01-.398-.165l-8.04-8.04A1.116 1.116 0 016 12.001c0-.3.116-.583.329-.795l8.04-8.041a.557.557 0 01.795 0 .557.557 0 01.165.397c0 .15-.058.292-.165.398L7.124 12l8.04 8.04a.558.558 0 010 .795.561.561 0 01-.397.165z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$l = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeft);

  function SvgChevronRight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.562 21c.15 0 .292-.058.398-.165l8.04-8.04c.212-.212.33-.494.33-.794 0-.3-.117-.583-.33-.795L8.96 3.165A.557.557 0 008.562 3a.557.557 0 00-.397.165.557.557 0 00-.165.397c0 .15.058.292.165.398l8.04 8.04-8.04 8.04a.558.558 0 000 .795.561.561 0 00.397.165z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$k = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRight);

  function SvgChevronUp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3 16.102c0-.15.058-.292.165-.398l8.04-8.04c.212-.212.494-.329.794-.329.3 0 .583.116.795.329l8.041 8.04a.557.557 0 010 .795.557.557 0 01-.795 0L12 8.46 3.96 16.5a.558.558 0 01-.795 0A.561.561 0 013 16.102z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$j = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUp);

  function SvgClose(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.438 21a.558.558 0 01-.398-.164L12 12.796l-8.04 8.04a.559.559 0 01-.795 0 .564.564 0 010-.796l8.04-8.04-8.04-8.04A.557.557 0 013 3.564c0-.15.058-.292.165-.397A.557.557 0 013.562 3c.15 0 .292.058.398.165L12 11.205l8.04-8.04a.558.558 0 01.795 0 .56.56 0 010 .796L12.795 12l8.04 8.04a.564.564 0 01-.398.96z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$i = /*#__PURE__*/React__namespace.forwardRef(SvgClose);

  function SvgLoading(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21 12c0-2.21-.796-4.233-2.118-5.8A9 9 0 1012 21",
      stroke: "url(#loading_svg__paint0_angular)",
      strokeLinecap: "round"
    }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("radialGradient", {
      id: "loading_svg__paint0_angular",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "rotate(68.2 -2.862 14.862) scale(9.08754)"
    }, /*#__PURE__*/React__namespace.createElement("stop", {
      offset: 0.042,
      stopOpacity: 0
    }), /*#__PURE__*/React__namespace.createElement("stop", {
      offset: 0.824
    }))));
  }

  var ForwardRef$h = /*#__PURE__*/React__namespace.forwardRef(SvgLoading);

  function SvgMicrophoneOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M84.082 106.097a35 35 0 01-46.165-33.18V58.333M41.09 23.333a35 35 0 0166.827 14.584v35a34.813 34.813 0 01-3.18 14.583M113.517 96.203a47.028 47.028 0 006.066-23.286V61.25",
      strokeWidth: 5.83333
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M26.25 61.25v11.667a46.258 46.258 0 0046.667 46.666 46.976 46.976 0 0023.199-6.02M72.917 119.583v17.5M5.833 5.833l128.334 128.334",
      strokeWidth: 5.83333
    })));
  }

  var ForwardRef$g = /*#__PURE__*/React__namespace.forwardRef(SvgMicrophoneOff);

  function SvgMicrophoneOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M105 72.917a35 35 0 01-70 0v-35a35 35 0 0170 0z",
      strokeWidth: 5.83333
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M23.333 61.25v11.667A46.252 46.252 0 0070 119.583a46.258 46.258 0 0046.667-46.666V61.25M70 119.583v17.5M70 2.917v17.5M81.672 4.912l-.005 15.505M58.333 4.912v15.505M23.333 72.917h93.334M35 37.917h23.333M35 49.583h23.333M105 37.917H81.667M105 49.583H81.667M35 61.25h23.333M105 61.25H81.667",
      strokeWidth: 5.83333
    })));
  }

  var ForwardRef$f = /*#__PURE__*/React__namespace.forwardRef(SvgMicrophoneOn);

  function SvgNav1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M54.612 120.33a15.313 15.313 0 1030.625 0 15.313 15.313 0 10-30.625 0zM54.612 19.705a15.313 15.313 0 1030.625 0 15.313 15.313 0 10-30.625 0zM54.612 70.017a15.313 15.313 0 1030.625 0 15.313 15.313 0 10-30.625 0z",
      strokeWidth: 8.749995
    })));
  }

  var ForwardRef$e = /*#__PURE__*/React__namespace.forwardRef(SvgNav1);

  function SvgPhone(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 140 140",
      width: "1em",
      height: "1em",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M87.733 130.608l.07.041a32.276 32.276 0 0040.157-4.404l4.515-4.515a10.768 10.768 0 000-15.22L113.452 87.5a10.768 10.768 0 00-15.219 0h0a10.75 10.75 0 01-15.213 0L52.582 57.056a10.768 10.768 0 010-15.22h0a10.75 10.75 0 000-15.213L33.565 7.583a10.768 10.768 0 00-15.22 0l-4.514 4.515a32.288 32.288 0 00-4.41 40.157l.046.07a291.288 291.288 0 0078.266 78.283z",
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8.749995
    }));
  }

  var ForwardRef$d = /*#__PURE__*/React__namespace.forwardRef(SvgPhone);

  function SvgRadioEmpty(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm0 18.333A8.333 8.333 0 1120.333 12 8.342 8.342 0 0112 20.333z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$c = /*#__PURE__*/React__namespace.forwardRef(SvgRadioEmpty);

  function SvgRadioSelected(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.444 3.685A10 10 0 0112 2a10.01 10.01 0 0110 10A10 10 0 116.444 3.685zM7.37 18.93A8.333 8.333 0 0012 20.333 8.342 8.342 0 0020.333 12 8.333 8.333 0 107.37 18.929zM12 6a6 6 0 106 6 6.007 6.007 0 00-6-6z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$b = /*#__PURE__*/React__namespace.forwardRef(SvgRadioSelected);

  function SvgRefresh(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.098 17.995H2.625a.625.625 0 010-1.25h2.197a8.744 8.744 0 01-1.562-5.183A8.694 8.694 0 015.957 5.43 8.716 8.716 0 0112.012 3a8.71 8.71 0 013.355.67.623.623 0 01.338.817.624.624 0 01-.818.336 7.459 7.459 0 00-2.875-.574c-1.944 0-3.787.74-5.19 2.083a7.452 7.452 0 00-2.313 5.256 7.48 7.48 0 001.241 4.299v-2.268A.625.625 0 117 13.62v3.75c0 .345-.28.625-.625.625h-.198a.297.297 0 01-.038.002l-.042-.002zM11.996 20.497a8.713 8.713 0 01-3.365-.674.622.622 0 01-.337-.817.624.624 0 01.817-.338c.92.384 1.89.579 2.885.579a7.466 7.466 0 005.195-2.09 7.451 7.451 0 002.306-5.259A7.478 7.478 0 0018.249 7.6v2.27a.625.625 0 01-1.249 0V6.12c0-.345.28-.625.625-.625h3.75a.625.625 0 010 1.25h-2.196a8.753 8.753 0 011.569 5.18 8.698 8.698 0 01-2.69 6.134 8.716 8.716 0 01-6.062 2.438z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$a = /*#__PURE__*/React__namespace.forwardRef(SvgRefresh);

  function SvgRemove(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.625 12.032h18.75",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  }

  var ForwardRef$9 = /*#__PURE__*/React__namespace.forwardRef(SvgRemove);

  function SvgRoundCheckEmpty(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm0 18.333A8.333 8.333 0 1120.333 12 8.342 8.342 0 0112 20.333z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$8 = /*#__PURE__*/React__namespace.forwardRef(SvgRoundCheckEmpty);

  function SvgRoundCheckOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.4 7.374a1.04 1.04 0 00-1.456.221l-4.937 6.7-3.139-2.512a1.042 1.042 0 00-1.302 1.628l3.986 3.188a1.052 1.052 0 001.489-.196l5.583-7.572a1.042 1.042 0 00-.224-1.457z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm0 18.333A8.333 8.333 0 1120.333 12 8.342 8.342 0 0112 20.333z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$7 = /*#__PURE__*/React__namespace.forwardRef(SvgRoundCheckOn);

  function SvgSearch(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.438 21.001a.557.557 0 01-.398-.165l-4.885-4.886a7.369 7.369 0 01-1.915 1.184 7.323 7.323 0 01-5.631.052A7.308 7.308 0 013.59 13.24 7.31 7.31 0 013.54 7.61 7.311 7.311 0 017.484 3.59a7.307 7.307 0 015.631-.052 7.308 7.308 0 014.019 3.946 7.31 7.31 0 01.051 5.632 7.355 7.355 0 01-1.236 2.038l4.887 4.887a.564.564 0 01-.398.96zM10.36 4.125c-.836 0-1.657.168-2.437.5A6.194 6.194 0 004.58 8.029a6.194 6.194 0 00.043 4.771 6.195 6.195 0 003.405 3.343 6.209 6.209 0 004.77-.044 6.212 6.212 0 001.946-1.302.273.273 0 01.058-.057 6.183 6.183 0 001.339-2.046 6.19 6.19 0 00-.045-4.77 6.192 6.192 0 00-3.404-3.343 6.21 6.21 0 00-2.332-.456z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$6 = /*#__PURE__*/React__namespace.forwardRef(SvgSearch);

  function SvgSquareCheckEmpty(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.5 3h-15A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0019.5 3zm0 16.313a.188.188 0 01-.188.187H4.688a.187.187 0 01-.187-.188V4.688a.187.187 0 01.188-.187h14.625a.188.188 0 01.187.188v14.625z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$5 = /*#__PURE__*/React__namespace.forwardRef(SvgSquareCheckEmpty);

  function SvgSquareCheckOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.056 7.682a.937.937 0 00-1.311.199l-4.671 6.34-2.989-2.391a.94.94 0 00-1.503.463.937.937 0 00.332 1l3.75 3a.926.926 0 00.586.203.941.941 0 00.755-.375l5.25-7.126a.935.935 0 00-.2-1.313z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.5 3h-15A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0019.5 3zm0 16.313a.188.188 0 01-.188.187H4.688a.187.187 0 01-.187-.188V4.688a.187.187 0 01.188-.187h14.625a.188.188 0 01.187.188v14.625z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$4 = /*#__PURE__*/React__namespace.forwardRef(SvgSquareCheckOn);

  function SvgTrashBin(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.228 22a2.011 2.011 0 01-1.993-1.835L4.053 6H2.667a.667.667 0 010-1.333H8V4c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v.667h5.333a.667.667 0 010 1.333h-1.386l-1.18 14.166A2.011 2.011 0 0116.772 22H7.228zm-.665-1.945a.67.67 0 00.665.612h9.545a.67.67 0 00.664-.612L18.61 6H5.39l1.172 14.055zm8.104-15.388V4A.667.667 0 0014 3.333h-4A.667.667 0 009.333 4v.667h5.334z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10 17.333a.667.667 0 01-.667-.666V10a.667.667 0 011.334 0v6.667a.667.667 0 01-.667.666zM14 17.333a.667.667 0 01-.667-.666V10a.667.667 0 011.334 0v6.667a.667.667 0 01-.667.666z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$3 = /*#__PURE__*/React__namespace.forwardRef(SvgTrashBin);

  function SvgViewOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.319 19.448a.62.62 0 01-.432-1.076L19.508 3.374a.62.62 0 01.883.018.623.623 0 01-.017.884L4.752 19.276a.627.627 0 01-.433.173zM11.988 18.198l-.091.001a8.838 8.838 0 01-2.614-.402.626.626 0 01.37-1.194c.74.23 1.5.347 2.258.347h.207c3.21 0 6.463-2.32 8.437-4.493a.758.758 0 00-.002-1.016 16.487 16.487 0 00-2.465-2.21.621.621 0 01-.137-.873.627.627 0 01.873-.138c.96.701 1.854 1.503 2.656 2.382.693.769.693 1.926.002 2.693-2.154 2.372-5.745 4.905-9.363 4.905l-.13-.002zM5.148 15.5a.626.626 0 01-.384-.132 18.019 18.019 0 01-2.243-2.072 2.007 2.007 0 01-.003-2.694C4.673 8.23 8.264 5.699 11.88 5.699h.198c.705 0 1.405.086 2.083.255a.624.624 0 11-.303 1.213 7.338 7.338 0 00-1.774-.217h-.19c-3.22 0-6.475 2.32-8.45 4.492a.758.758 0 00.002 1.017 16.786 16.786 0 002.086 1.925.621.621 0 01.11.876c-.12.15-.3.24-.494.24z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.874 12.574a.626.626 0 01-.625-.625c0-1 .39-1.94 1.098-2.65a3.72 3.72 0 012.649-1.1c.172 0 .312.14.313.312l.001.625a.315.315 0 01-.09.222.309.309 0 01-.222.091c-.667 0-1.294.261-1.767.733A2.482 2.482 0 009.5 11.95a.623.623 0 01-.625.625zM12 15.698a.312.312 0 01-.313-.312l-.001-.625a.31.31 0 01.092-.22.31.31 0 01.22-.092c.669 0 1.296-.26 1.769-.733.471-.472.731-1.1.731-1.768a.625.625 0 011.25 0c0 1.002-.39 1.943-1.097 2.651a3.726 3.726 0 01-2.652 1.1z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$2 = /*#__PURE__*/React__namespace.forwardRef(SvgViewOff);

  function SvgViewOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.868 18.498c-3.61 0-7.196-2.533-9.348-4.903a2.007 2.007 0 01-.002-2.693C4.67 8.532 8.26 6 11.878 6h.254c3.606 0 7.194 2.531 9.348 4.9.693.77.693 1.927.002 2.694-2.155 2.372-5.747 4.905-9.37 4.905l-.124-.001h-.12zm.009-11.249c-3.209 0-6.46 2.32-8.433 4.491a.758.758 0 00.002 1.017c1.972 2.17 5.222 4.491 8.433 4.491h.222c3.222 0 6.48-2.32 8.453-4.493a.758.758 0 00-.001-1.016c-1.973-2.17-5.226-4.49-8.435-4.49l-.13.002-.111-.002z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.998 15.997a3.726 3.726 0 01-2.652-1.099 3.72 3.72 0 01-1.097-2.651 3.753 3.753 0 013.75-3.749c1.001 0 1.943.39 2.65 1.098a3.723 3.723 0 011.1 2.65c0 1.005-.392 1.946-1.1 2.654A3.726 3.726 0 0112 15.997h-.001zm.001-6.249c-1.378 0-2.5 1.12-2.5 2.499 0 .667.26 1.296.732 1.767.473.473 1.1.733 1.768.733.668 0 1.295-.26 1.767-.732s.732-1.1.732-1.767c0-.67-.26-1.298-.732-1.77-.472-.47-1.1-.73-1.767-.73z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1 = /*#__PURE__*/React__namespace.forwardRef(SvgViewOn);

  function SvgWarning(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 13.667a.834.834 0 01-.833-.834V6.167a.834.834 0 011.666 0v6.666c0 .46-.373.834-.833.834zM12 17.833a.882.882 0 01-.145-.012 1.25 1.25 0 01-1.092-1.091.796.796 0 010-.291 1.252 1.252 0 011.092-1.092.893.893 0 01.29 0c.57.067 1.025.522 1.092 1.092a.907.907 0 010 .291A1.25 1.25 0 0112 17.833z",
      fill: "currentcolor"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm0-18.333c-4.594 0-8.333 3.739-8.333 8.333S7.406 20.333 12 20.333s8.333-3.739 8.333-8.333S16.596 3.667 12 3.667z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef = /*#__PURE__*/React__namespace.forwardRef(SvgWarning);

  exports.MiscBoldAgreement = ForwardRef$2d;
  exports.MiscBoldBirthdaycake = ForwardRef$2c;
  exports.MiscBoldBrowserurl = ForwardRef$2b;
  exports.MiscBoldCamera = ForwardRef$2a;
  exports.MiscBoldCar = ForwardRef$29;
  exports.MiscBoldDependente = ForwardRef$28;
  exports.MiscBoldEdit = ForwardRef$27;
  exports.MiscBoldFold = ForwardRef$26;
  exports.MiscBoldGenderfemale = ForwardRef$25;
  exports.MiscBoldGendermale = ForwardRef$24;
  exports.MiscBoldGlasses = ForwardRef$23;
  exports.MiscBoldHealthinsurance = ForwardRef$22;
  exports.MiscBoldHyperlink = ForwardRef$21;
  exports.MiscBoldLock = ForwardRef$20;
  exports.MiscBoldMail = ForwardRef$1$;
  exports.MiscBoldPhone = ForwardRef$1_;
  exports.MiscBoldPin = ForwardRef$1Z;
  exports.MiscBoldQuestioncircle = ForwardRef$1Y;
  exports.MiscBoldQuit = ForwardRef$1X;
  exports.MiscBoldShare = ForwardRef$1W;
  exports.MiscBoldSyringe = ForwardRef$1V;
  exports.MiscBoldTerms = ForwardRef$1U;
  exports.MiscBoldTextballoon = ForwardRef$1T;
  exports.MiscBoldTime = ForwardRef$1S;
  exports.MiscBoldUser = ForwardRef$1R;
  exports.MiscBoldUserid = ForwardRef$1Q;
  exports.MiscBoldUsersquare = ForwardRef$1P;
  exports.MiscBoldWhatsapp = ForwardRef$1O;
  exports.MiscBoldWifi = ForwardRef$1N;
  exports.MiscOutlineAgreement = ForwardRef$1M;
  exports.MiscOutlineBirthdaycake = ForwardRef$1L;
  exports.MiscOutlineBrowserurl = ForwardRef$1K;
  exports.MiscOutlineCalendar = ForwardRef$1J;
  exports.MiscOutlineCamera = ForwardRef$1I;
  exports.MiscOutlineCar = ForwardRef$1H;
  exports.MiscOutlineDependente = ForwardRef$1G;
  exports.MiscOutlineEdit = ForwardRef$1F;
  exports.MiscOutlineExternallink = ForwardRef$1E;
  exports.MiscOutlineFold = ForwardRef$1D;
  exports.MiscOutlineGenderfemale = ForwardRef$1C;
  exports.MiscOutlineGendermale = ForwardRef$1B;
  exports.MiscOutlineGlasses = ForwardRef$1A;
  exports.MiscOutlineGraph = ForwardRef$1z;
  exports.MiscOutlineHealthinsurance = ForwardRef$1y;
  exports.MiscOutlineHyperlink = ForwardRef$1x;
  exports.MiscOutlineLight = ForwardRef$1w;
  exports.MiscOutlineLock = ForwardRef$1v;
  exports.MiscOutlineMail = ForwardRef$1u;
  exports.MiscOutlinePhone = ForwardRef$1t;
  exports.MiscOutlinePin = ForwardRef$1s;
  exports.MiscOutlineQuestioncircle = ForwardRef$1r;
  exports.MiscOutlineQuit = ForwardRef$1q;
  exports.MiscOutlineShare = ForwardRef$1p;
  exports.MiscOutlineSyringe = ForwardRef$1o;
  exports.MiscOutlineTerms = ForwardRef$1n;
  exports.MiscOutlineTextballoon = ForwardRef$1m;
  exports.MiscOutlineTime = ForwardRef$1l;
  exports.MiscOutlineUser = ForwardRef$1k;
  exports.MiscOutlineUserid = ForwardRef$1j;
  exports.MiscOutlineUsersquare = ForwardRef$1i;
  exports.MiscOutlineWhatsapp = ForwardRef$1h;
  exports.MiscOutlineWifi = ForwardRef$1g;
  exports.NavBoldAvatar = ForwardRef$1f;
  exports.NavBoldBell = ForwardRef$1e;
  exports.NavBoldHeartbeat = ForwardRef$1d;
  exports.NavBoldHome = ForwardRef$1c;
  exports.NavOutlineAvatar = ForwardRef$1b;
  exports.NavOutlineBell = ForwardRef$1a;
  exports.NavOutlineHeartbeat = ForwardRef$19;
  exports.NavOutlineHome = ForwardRef$18;
  exports.ServicesBoldDoctor = ForwardRef$17;
  exports.ServicesBoldDrop = ForwardRef$16;
  exports.ServicesBoldHospital = ForwardRef$15;
  exports.ServicesBoldLab = ForwardRef$14;
  exports.ServicesBoldMeet = ForwardRef$13;
  exports.ServicesBoldRdi = ForwardRef$12;
  exports.ServicesBoldTelemedicine = ForwardRef$11;
  exports.ServicesOutlineDoctor = ForwardRef$10;
  exports.ServicesOutlineDrop = ForwardRef$$;
  exports.ServicesOutlineHospital = ForwardRef$_;
  exports.ServicesOutlineLab = ForwardRef$Z;
  exports.ServicesOutlineMeet = ForwardRef$Y;
  exports.ServicesOutlineRdi = ForwardRef$X;
  exports.ServicesOutlineTelemedicine = ForwardRef$W;
  exports.SystemBoldAdd = ForwardRef$V;
  exports.SystemBoldArrowleft = ForwardRef$U;
  exports.SystemBoldCameraoff = ForwardRef$T;
  exports.SystemBoldCameraon = ForwardRef$S;
  exports.SystemBoldCheckmark = ForwardRef$R;
  exports.SystemBoldChevrondown = ForwardRef$Q;
  exports.SystemBoldChevronleft = ForwardRef$P;
  exports.SystemBoldChevronright = ForwardRef$O;
  exports.SystemBoldChevronup = ForwardRef$N;
  exports.SystemBoldClose = ForwardRef$M;
  exports.SystemBoldExclam = ForwardRef$L;
  exports.SystemBoldLoading = ForwardRef$K;
  exports.SystemBoldMicrophoneoff = ForwardRef$J;
  exports.SystemBoldMicrophoneon = ForwardRef$I;
  exports.SystemBoldNav1 = ForwardRef$H;
  exports.SystemBoldPhone = ForwardRef$G;
  exports.SystemBoldRefresh = ForwardRef$F;
  exports.SystemBoldRemove = ForwardRef$E;
  exports.SystemBoldRoundcheckempty = ForwardRef$D;
  exports.SystemBoldRoundcheckon = ForwardRef$C;
  exports.SystemBoldSearch = ForwardRef$B;
  exports.SystemBoldSquarecheckempty = ForwardRef$A;
  exports.SystemBoldSquarecheckon = ForwardRef$z;
  exports.SystemBoldTrashbin = ForwardRef$y;
  exports.SystemBoldViewoff = ForwardRef$x;
  exports.SystemBoldViewon = ForwardRef$w;
  exports.SystemBoldWarning = ForwardRef$v;
  exports.SystemOutlineAdd = ForwardRef$u;
  exports.SystemOutlineApp = ForwardRef$t;
  exports.SystemOutlineArrowleft = ForwardRef$s;
  exports.SystemOutlineCameraoff = ForwardRef$r;
  exports.SystemOutlineCameraon = ForwardRef$q;
  exports.SystemOutlineCameraswitch = ForwardRef$p;
  exports.SystemOutlineCheckboxempty = ForwardRef$o;
  exports.SystemOutlineCheckboxselected = ForwardRef$n;
  exports.SystemOutlineChevrondown = ForwardRef$m;
  exports.SystemOutlineChevronleft = ForwardRef$l;
  exports.SystemOutlineChevronright = ForwardRef$k;
  exports.SystemOutlineChevronup = ForwardRef$j;
  exports.SystemOutlineClose = ForwardRef$i;
  exports.SystemOutlineLoading = ForwardRef$h;
  exports.SystemOutlineMicrophoneoff = ForwardRef$g;
  exports.SystemOutlineMicrophoneon = ForwardRef$f;
  exports.SystemOutlineNav1 = ForwardRef$e;
  exports.SystemOutlinePhone = ForwardRef$d;
  exports.SystemOutlineRadioempty = ForwardRef$c;
  exports.SystemOutlineRadioselected = ForwardRef$b;
  exports.SystemOutlineRefresh = ForwardRef$a;
  exports.SystemOutlineRemove = ForwardRef$9;
  exports.SystemOutlineRoundcheckempty = ForwardRef$8;
  exports.SystemOutlineRoundcheckon = ForwardRef$7;
  exports.SystemOutlineSearch = ForwardRef$6;
  exports.SystemOutlineSquarecheckempty = ForwardRef$5;
  exports.SystemOutlineSquarecheckon = ForwardRef$4;
  exports.SystemOutlineTrashbin = ForwardRef$3;
  exports.SystemOutlineViewoff = ForwardRef$2;
  exports.SystemOutlineViewon = ForwardRef$1;
  exports.SystemOutlineWarning = ForwardRef;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
